"use strict";
/**
 * This is a generated file. Please do not edit.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatChannelStatus = exports.ChatChannelOrder = exports.CarrierOrderStatus = exports.CarrierDriverOrderByInput = exports.BusinessAccountType = exports.BRSubdivisionAbbreviation = exports.BRState = exports.BackgroundCheckUpdateEntityType = exports.BackgroundCheckSupportingDocumentType = exports.BackgroundCheckStepType = exports.BackgroundCheckStepStatus = exports.BackgroundCheckStepEventType = exports.BackgroundCheckStatus = exports.BackgroundCheckDisplayStatus = exports.BacenStatus = exports.ARSubdivisionAbbreviation = exports.ApplicationUserExperience = exports.Application = exports.AnalysisStatus = exports.AgStateName = exports.AgMatriculaDetailType = exports.AgFinancingRequestStatuses = exports.AgFinancingPolls = exports.AgFinancingPhaseStatus = exports.AgFinancingPhases = exports.AgFinancingPhase4Status = exports.AgFinancingPhase3Status = exports.AgFinancingPhase2Status = exports.AgFinancingFileStatus = exports.AgFinancingFilesContext = exports.AgFinancingFileInternalStatus = exports.AgFinancingFileFolder = exports.AgFinancingEvaluationType = exports.AgFinancingDocumentType = exports.AgFinancingDebtType = exports.AgFinancingCreditApprovalStatus = exports.AgFinancingCreditAnalysisStatus = exports.AgFinancingCountryCode = exports.AgFinancingCollateralAnalysisStatus = exports.AGFFilterAscDesc = exports.AgConversationContext = exports.AddressType = exports.ActivityType = exports.AccountUserType = exports.AccountUsersOrderByInput = exports.AccountType = exports.AccountsOrderByInput = exports.AccountRoleRequestOrderByInput = exports.AccountInviteStatus = exports.AccountInviteOrderByInput = void 0;
exports.OrderUnassignableStatus = exports.OrderReasonNotCancelable = exports.OrderCancelationStatus = exports.OpportunityType = exports.OpportunitySaleType = exports.OpportunityRegional = exports.MyAccountsOrderByInput = exports.MonthCode = exports.Month = exports.MatriculaTerritoryStatusQuery = exports.MatriculaBiome = exports.MarketplaceGrowerRoles = exports.MarketplaceAdminRoles = exports.LegalEntityType = exports.JudicialActionFlag = exports.Irrigation = exports.HtmlSnapshotType = exports.HardRedWinterWheatVariety = exports.Grain = exports.FuturesMonthCode = exports.FinancingProcessBrEventType = exports.FinancingFixGrainPriceTiming = exports.FinancingCivilStatus = exports.FinancingApplicationStatus = exports.FieldMonitoringStatus = exports.ERROR_CODE = exports.EmailStatus = exports.ElevatorMetricsType = exports.DistanceUnit = exports.Distance = exports.DevicePlatform = exports.DecisionBackgroundCheckStepStatus = exports.CurrencyCode = exports.CropWeightUnit = exports.CropQuantityUnit = exports.Crop = exports.CreditException = exports.CreditConditional = exports.CreditApprovalStepType = exports.CreditApprovalStepStatus = exports.CreditApprovalStepDecision = exports.CreditApprovalRoundStatus = exports.CprStatus = exports.CountryCode = exports.CottonVariety = exports.CornVariety = exports.ContractStatus = exports.CollateralType = exports.ChatMessageType = exports.ChatChannelType = void 0;
exports.TruckingPricingSource = exports.TruckingPricingRate = exports.TruckingPricingOverrideType = exports.TruckingPricingModelFilter = exports.TruckingOrderState = exports.TruckingOrderByInput = exports.TruckingDocumentType = exports.TruckingDocumentStatus = exports.TruckingCarrierStatus = exports.TruckingCarrierPaymentType = exports.TruckingCarrierOrderByInput = exports.TruckingAgreementType = exports.TripUncancelableReason = exports.TransportUserType = exports.TransportRateType = exports.TransportOrderStatus = exports.TransportOrderSortBy = exports.TransportOpenOfferStatus = exports.TransportFreightRequestOrderByInput = exports.TransportDirectOfferStatus = exports.TransportCounterOfferStatus = exports.TransportCarrierLoadStatus = exports.TransportCarrierFreightRequestOfferType = exports.TinVerificationStatus = exports.TextMessageType = exports.TextMessageDirection = exports.TenderingParty = exports.Stage = exports.SoyVariety = exports.SortDirection = exports.SoilTillage = exports.SoilGrade = exports.SoftRedWinterWheatVariety = exports.ShippingOrderGeneralStatus = exports.ShipperStatus = exports.ShipperShippingOrderLoadOrderByInput = exports.ShipperLoadGeneralStatus = exports.ShipperCarrierOrderHistoryOrderByInput = exports.SerasaOccurrence = exports.SerasaApiStatus = exports.Season = exports.SalesRegion = exports.RoleOrderByInput = exports.RiskClassificationStatus = exports.RiskClassificationLevel = exports.RiceVariety = exports.PledgeLevel = exports.PermissionOrderByInput = exports.PendencyStatus = exports.OrganicHardRedWinterWheatVariety = void 0;
exports.YieldUnit = exports.USSubdivisionAbbreviation = exports.USStateAbbreviation = exports.USState = exports.UsersOrderByInput = exports.UserRole = exports.UserAgreementType = exports.UnitOfMeasure = exports.UndefinedCropVariety = exports.TruckingTripStatusFilter = exports.TruckingTripState = exports.TruckingTripProgressStatus = exports.TruckingTripPaymentStatus = exports.TruckingTripIssueStatus = exports.TruckingTripIssueOrderByInput = exports.TruckingTripDeliveryType = exports.TruckingTripDeliveryStatus = exports.TruckingTripAccessorialChargeType = exports.TruckingStorageType = exports.TruckingQuoteStatus = exports.TruckingQuoteOrderByInput = exports.TruckingPricingType = void 0;
/* eslint-disable */
var AccountInviteOrderByInput;
(function (AccountInviteOrderByInput) {
    AccountInviteOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    AccountInviteOrderByInput["createdAt_DESC"] = "createdAt_DESC";
})(AccountInviteOrderByInput = exports.AccountInviteOrderByInput || (exports.AccountInviteOrderByInput = {}));
var AccountInviteStatus;
(function (AccountInviteStatus) {
    AccountInviteStatus["PENDING"] = "PENDING";
    AccountInviteStatus["ACCEPTED"] = "ACCEPTED";
    AccountInviteStatus["REVOKED"] = "REVOKED";
    AccountInviteStatus["DENIED"] = "DENIED";
    AccountInviteStatus["CLAIMED"] = "CLAIMED";
})(AccountInviteStatus = exports.AccountInviteStatus || (exports.AccountInviteStatus = {}));
var AccountRoleRequestOrderByInput;
(function (AccountRoleRequestOrderByInput) {
    AccountRoleRequestOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    AccountRoleRequestOrderByInput["createdAt_DESC"] = "createdAt_DESC";
    AccountRoleRequestOrderByInput["recipientEmail_ASC"] = "recipientEmail_ASC";
    AccountRoleRequestOrderByInput["recipientEmail_DESC"] = "recipientEmail_DESC";
})(AccountRoleRequestOrderByInput = exports.AccountRoleRequestOrderByInput || (exports.AccountRoleRequestOrderByInput = {}));
var AccountsOrderByInput;
(function (AccountsOrderByInput) {
    AccountsOrderByInput["name_ASC"] = "name_ASC";
    AccountsOrderByInput["name_DESC"] = "name_DESC";
    AccountsOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    AccountsOrderByInput["createdAt_DESC"] = "createdAt_DESC";
})(AccountsOrderByInput = exports.AccountsOrderByInput || (exports.AccountsOrderByInput = {}));
var AccountType;
(function (AccountType) {
    AccountType["GLOBAL"] = "GLOBAL";
    AccountType["ENTITY"] = "ENTITY";
    AccountType["BUYER"] = "BUYER";
    AccountType["FACILITY"] = "FACILITY";
    AccountType["SEED_MULTIPLIER"] = "SEED_MULTIPLIER";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AccountUsersOrderByInput;
(function (AccountUsersOrderByInput) {
    AccountUsersOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    AccountUsersOrderByInput["createdAt_DESC"] = "createdAt_DESC";
    AccountUsersOrderByInput["firstName_ASC"] = "firstName_ASC";
    AccountUsersOrderByInput["firstName_DESC"] = "firstName_DESC";
    AccountUsersOrderByInput["lastName_ASC"] = "lastName_ASC";
    AccountUsersOrderByInput["lastName_DESC"] = "lastName_DESC";
    AccountUsersOrderByInput["email_ASC"] = "email_ASC";
    AccountUsersOrderByInput["email_DESC"] = "email_DESC";
})(AccountUsersOrderByInput = exports.AccountUsersOrderByInput || (exports.AccountUsersOrderByInput = {}));
var AccountUserType;
(function (AccountUserType) {
    AccountUserType["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    AccountUserType["AGRONOMIST"] = "AGRONOMIST";
    AccountUserType["GROWER"] = "GROWER";
    AccountUserType["BUYER"] = "BUYER";
    AccountUserType["TRUCKING_CARRIER"] = "TRUCKING_CARRIER";
    AccountUserType["TRUCKING_DRIVER"] = "TRUCKING_DRIVER";
    AccountUserType["TRANSPORT_SHIPPER"] = "TRANSPORT_SHIPPER";
    AccountUserType["SHIPPING_SHIPPER"] = "SHIPPING_SHIPPER";
    AccountUserType["FINANCING_APPLICANT"] = "FINANCING_APPLICANT";
    AccountUserType["FINANCING_MULTIPLIER"] = "FINANCING_MULTIPLIER";
    AccountUserType["FINANCING_ADMIN"] = "FINANCING_ADMIN";
    AccountUserType["FINANCING_BRAZIL_GROWER"] = "FINANCING_BRAZIL_GROWER";
})(AccountUserType = exports.AccountUserType || (exports.AccountUserType = {}));
var ActivityType;
(function (ActivityType) {
    ActivityType["GRAIN_PRODUCTION"] = "GRAIN_PRODUCTION";
    ActivityType["WAREHOUSE_SERVICE"] = "WAREHOUSE_SERVICE";
    ActivityType["OTHER_SERVICES"] = "OTHER_SERVICES";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
var AddressType;
(function (AddressType) {
    AddressType["BUSINESS"] = "BUSINESS";
    AddressType["REMIT_TO"] = "REMIT_TO";
    AddressType["BILL_TO"] = "BILL_TO";
    AddressType["SHIP_TO"] = "SHIP_TO";
    AddressType["SHIP_FROM"] = "SHIP_FROM";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var AgConversationContext;
(function (AgConversationContext) {
    AgConversationContext["PHASE_1"] = "PHASE_1";
    AgConversationContext["PHASE_2"] = "PHASE_2";
    AgConversationContext["PHASE_3"] = "PHASE_3";
    AgConversationContext["CREDIT_ANALYSIS_ON_HOLD"] = "CREDIT_ANALYSIS_ON_HOLD";
    AgConversationContext["COLLATERAL_ANALYSIS_ON_HOLD"] = "COLLATERAL_ANALYSIS_ON_HOLD";
    AgConversationContext["FIELD_MONITORING_ON_HOLD"] = "FIELD_MONITORING_ON_HOLD";
})(AgConversationContext = exports.AgConversationContext || (exports.AgConversationContext = {}));
var AGFFilterAscDesc;
(function (AGFFilterAscDesc) {
    AGFFilterAscDesc["ASC"] = "ASC";
    AGFFilterAscDesc["DESC"] = "DESC";
})(AGFFilterAscDesc = exports.AGFFilterAscDesc || (exports.AGFFilterAscDesc = {}));
var AgFinancingCollateralAnalysisStatus;
(function (AgFinancingCollateralAnalysisStatus) {
    AgFinancingCollateralAnalysisStatus["STARTED"] = "STARTED";
    AgFinancingCollateralAnalysisStatus["COMPLETED"] = "COMPLETED";
    AgFinancingCollateralAnalysisStatus["ON_HOLD"] = "ON_HOLD";
    AgFinancingCollateralAnalysisStatus["APPROVED"] = "APPROVED";
    AgFinancingCollateralAnalysisStatus["DENIED"] = "DENIED";
    AgFinancingCollateralAnalysisStatus["WAITING_CREDIT_MANAGER_DECISION"] = "WAITING_CREDIT_MANAGER_DECISION";
})(AgFinancingCollateralAnalysisStatus = exports.AgFinancingCollateralAnalysisStatus || (exports.AgFinancingCollateralAnalysisStatus = {}));
var AgFinancingCountryCode;
(function (AgFinancingCountryCode) {
    AgFinancingCountryCode["ARG"] = "ARG";
    AgFinancingCountryCode["BRA"] = "BRA";
})(AgFinancingCountryCode = exports.AgFinancingCountryCode || (exports.AgFinancingCountryCode = {}));
var AgFinancingCreditAnalysisStatus;
(function (AgFinancingCreditAnalysisStatus) {
    AgFinancingCreditAnalysisStatus["COMPLETED"] = "COMPLETED";
    AgFinancingCreditAnalysisStatus["ON_HOLD"] = "ON_HOLD";
    AgFinancingCreditAnalysisStatus["STARTED"] = "STARTED";
    AgFinancingCreditAnalysisStatus["APPROVED"] = "APPROVED";
    AgFinancingCreditAnalysisStatus["DENIED"] = "DENIED";
    AgFinancingCreditAnalysisStatus["WAITING_CREDIT_MANAGER_DECISION"] = "WAITING_CREDIT_MANAGER_DECISION";
})(AgFinancingCreditAnalysisStatus = exports.AgFinancingCreditAnalysisStatus || (exports.AgFinancingCreditAnalysisStatus = {}));
var AgFinancingCreditApprovalStatus;
(function (AgFinancingCreditApprovalStatus) {
    AgFinancingCreditApprovalStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AgFinancingCreditApprovalStatus["CREDIT_ANALYST_APPROVED"] = "CREDIT_ANALYST_APPROVED";
    AgFinancingCreditApprovalStatus["CREDIT_SUPERVISOR_APPROVED"] = "CREDIT_SUPERVISOR_APPROVED";
    AgFinancingCreditApprovalStatus["CREDIT_MANAGER_APPROVED"] = "CREDIT_MANAGER_APPROVED";
    AgFinancingCreditApprovalStatus["COMMERCIAL_DIRECTOR_APPROVED"] = "COMMERCIAL_DIRECTOR_APPROVED";
    AgFinancingCreditApprovalStatus["FINANCE_DIRECTOR_APPROVED"] = "FINANCE_DIRECTOR_APPROVED";
    AgFinancingCreditApprovalStatus["DENIED"] = "DENIED";
    AgFinancingCreditApprovalStatus["WAITING_CREDIT_MANAGER_DECISION"] = "WAITING_CREDIT_MANAGER_DECISION";
})(AgFinancingCreditApprovalStatus = exports.AgFinancingCreditApprovalStatus || (exports.AgFinancingCreditApprovalStatus = {}));
var AgFinancingDebtType;
(function (AgFinancingDebtType) {
    AgFinancingDebtType["BANK"] = "BANK";
    AgFinancingDebtType["AG_FINANCE"] = "AG_FINANCE";
    AgFinancingDebtType["OTHER"] = "OTHER";
    AgFinancingDebtType["SERASA"] = "SERASA";
})(AgFinancingDebtType = exports.AgFinancingDebtType || (exports.AgFinancingDebtType = {}));
var AgFinancingDocumentType;
(function (AgFinancingDocumentType) {
    AgFinancingDocumentType["CAR"] = "CAR";
    AgFinancingDocumentType["CESSION_OF_RIGHTS"] = "CESSION_OF_RIGHTS";
    AgFinancingDocumentType["LEASING_CONTRACT"] = "LEASING_CONTRACT";
    AgFinancingDocumentType["MATRICULA"] = "MATRICULA";
    AgFinancingDocumentType["OTHER"] = "OTHER";
    AgFinancingDocumentType["AMENDMENT"] = "AMENDMENT";
    AgFinancingDocumentType["AMENDMENT_SIGN"] = "AMENDMENT_SIGN";
    AgFinancingDocumentType["BALANCE_DRE"] = "BALANCE_DRE";
    AgFinancingDocumentType["CARD_OR_CNPJ"] = "CARD_OR_CNPJ";
    AgFinancingDocumentType["CONSENT_LETTER"] = "CONSENT_LETTER";
    AgFinancingDocumentType["CPF"] = "CPF";
    AgFinancingDocumentType["CPR_MINUTA"] = "CPR_MINUTA";
    AgFinancingDocumentType["SIGNED_CPR"] = "SIGNED_CPR";
    AgFinancingDocumentType["NOTARIZED_CPR"] = "NOTARIZED_CPR";
    AgFinancingDocumentType["NOTARIZED_CPR_B3"] = "NOTARIZED_CPR_B3";
    AgFinancingDocumentType["DRIVERS_LICENSE"] = "DRIVERS_LICENSE";
    AgFinancingDocumentType["FIELD_MONITORING_REPORT"] = "FIELD_MONITORING_REPORT";
    AgFinancingDocumentType["MARRIAGE_CERTIFICATE"] = "MARRIAGE_CERTIFICATE";
    AgFinancingDocumentType["PROMISSORY_NOTE"] = "PROMISSORY_NOTE";
    AgFinancingDocumentType["PROOF_OF_RESIDENCE"] = "PROOF_OF_RESIDENCE";
    AgFinancingDocumentType["PURCHASE_AND_SALE_CONTRACT"] = "PURCHASE_AND_SALE_CONTRACT";
    AgFinancingDocumentType["REGISTERED_CONTRACT"] = "REGISTERED_CONTRACT";
    AgFinancingDocumentType["REGISTERED_LETTER_OF_CONSENT"] = "REGISTERED_LETTER_OF_CONSENT";
    AgFinancingDocumentType["RG"] = "RG";
    AgFinancingDocumentType["IRPF_RECEIPT"] = "IRPF_RECEIPT";
    AgFinancingDocumentType["VISIT_HARVEST"] = "VISIT_HARVEST";
    AgFinancingDocumentType["VISIT_SEED_TREATMENT"] = "VISIT_SEED_TREATMENT";
    AgFinancingDocumentType["VISIT_FIRST_ASSESSMENT"] = "VISIT_FIRST_ASSESSMENT";
    AgFinancingDocumentType["VISIT_SECOND_ASSESSMENT"] = "VISIT_SECOND_ASSESSMENT";
    AgFinancingDocumentType["VISIT_PRE_CREDIT_REPORT"] = "VISIT_PRE_CREDIT_REPORT";
    AgFinancingDocumentType["PROMISSORY_NOTE_SIGNED"] = "PROMISSORY_NOTE_SIGNED";
    AgFinancingDocumentType["AF_POST_REGISTRATION_CERTIFICATE"] = "AF_POST_REGISTRATION_CERTIFICATE";
    AgFinancingDocumentType["IRPF_DECLARATION"] = "IRPF_DECLARATION";
    AgFinancingDocumentType["INCOME_STATEMENT"] = "INCOME_STATEMENT";
    AgFinancingDocumentType["GUARANTOR"] = "GUARANTOR";
    AgFinancingDocumentType["KML"] = "KML";
    AgFinancingDocumentType["SALESFORCE_DOCUMENT"] = "SALESFORCE_DOCUMENT";
    AgFinancingDocumentType["ISSUER"] = "ISSUER";
    AgFinancingDocumentType["CPR"] = "CPR";
    AgFinancingDocumentType["REGISTERED_MINUTA"] = "REGISTERED_MINUTA";
    AgFinancingDocumentType["CERTIFICATE_OF_PLEDGE"] = "CERTIFICATE_OF_PLEDGE";
    AgFinancingDocumentType["OTHER_VALIDATION"] = "OTHER_VALIDATION";
    AgFinancingDocumentType["SALES_SIMULATOR"] = "SALES_SIMULATOR";
    AgFinancingDocumentType["SUPPLIER_ORDER"] = "SUPPLIER_ORDER";
    AgFinancingDocumentType["DETAILED_ORDER"] = "DETAILED_ORDER";
    AgFinancingDocumentType["HARD_MONITORING_REPORT"] = "HARD_MONITORING_REPORT";
    AgFinancingDocumentType["FUND_ASSIGNMENT_TERM"] = "FUND_ASSIGNMENT_TERM";
    AgFinancingDocumentType["BACEN_AUTHORIZATION"] = "BACEN_AUTHORIZATION";
    AgFinancingDocumentType["SALES_REPORT"] = "SALES_REPORT";
    AgFinancingDocumentType["STATE_REGISTRATION"] = "STATE_REGISTRATION";
    AgFinancingDocumentType["MATRICULA_PATRIMONY"] = "MATRICULA_PATRIMONY";
    AgFinancingDocumentType["CREDIT_SHEET"] = "CREDIT_SHEET";
    AgFinancingDocumentType["SALESFORCE_CHATTER_ATTACHMENT"] = "SALESFORCE_CHATTER_ATTACHMENT";
    AgFinancingDocumentType["CREDIT_OPINION"] = "CREDIT_OPINION";
    AgFinancingDocumentType["SERASA"] = "SERASA";
    AgFinancingDocumentType["BIRTH_CERTIFICATE"] = "BIRTH_CERTIFICATE";
    AgFinancingDocumentType["DIVORCE_CERTIFICATE"] = "DIVORCE_CERTIFICATE";
    AgFinancingDocumentType["LAND_PURCHASE_AND_SALE_AGREEMENT"] = "LAND_PURCHASE_AND_SALE_AGREEMENT";
    AgFinancingDocumentType["DRE"] = "DRE";
    AgFinancingDocumentType["DEBT_RENEGOTIATION_TERM_PROCESSES_IN_AGREEMENT"] = "DEBT_RENEGOTIATION_TERM_PROCESSES_IN_AGREEMENT";
    AgFinancingDocumentType["DUPLICATE_INVOICE"] = "DUPLICATE_INVOICE";
    AgFinancingDocumentType["SIGNED_DUPLICATE_INVOICE"] = "SIGNED_DUPLICATE_INVOICE";
    AgFinancingDocumentType["DEBT_ACKNOWLEDGMENT"] = "DEBT_ACKNOWLEDGMENT";
    AgFinancingDocumentType["SIGNED_DEBT_ACKNOWLEDGMENT"] = "SIGNED_DEBT_ACKNOWLEDGMENT";
})(AgFinancingDocumentType = exports.AgFinancingDocumentType || (exports.AgFinancingDocumentType = {}));
var AgFinancingEvaluationType;
(function (AgFinancingEvaluationType) {
    AgFinancingEvaluationType["CLEAR"] = "CLEAR";
    AgFinancingEvaluationType["DENIED"] = "DENIED";
})(AgFinancingEvaluationType = exports.AgFinancingEvaluationType || (exports.AgFinancingEvaluationType = {}));
var AgFinancingFileFolder;
(function (AgFinancingFileFolder) {
    AgFinancingFileFolder["PHASE_1"] = "PHASE_1";
    AgFinancingFileFolder["PHASE_2"] = "PHASE_2";
    AgFinancingFileFolder["PHASE_3"] = "PHASE_3";
    AgFinancingFileFolder["CREDIT"] = "CREDIT";
    AgFinancingFileFolder["REQUEST"] = "REQUEST";
    AgFinancingFileFolder["SALESFORCE"] = "SALESFORCE";
    AgFinancingFileFolder["CONVERSATIONS"] = "CONVERSATIONS";
    AgFinancingFileFolder["GUARANTOR"] = "GUARANTOR";
    AgFinancingFileFolder["PATRIMONY"] = "PATRIMONY";
})(AgFinancingFileFolder = exports.AgFinancingFileFolder || (exports.AgFinancingFileFolder = {}));
var AgFinancingFileInternalStatus;
(function (AgFinancingFileInternalStatus) {
    AgFinancingFileInternalStatus["OLD"] = "OLD";
    AgFinancingFileInternalStatus["ACTIVE"] = "ACTIVE";
})(AgFinancingFileInternalStatus = exports.AgFinancingFileInternalStatus || (exports.AgFinancingFileInternalStatus = {}));
var AgFinancingFilesContext;
(function (AgFinancingFilesContext) {
    AgFinancingFilesContext["IBAMA"] = "IBAMA";
    AgFinancingFilesContext["SERASA"] = "SERASA";
    AgFinancingFilesContext["LABOR"] = "LABOR";
    AgFinancingFilesContext["STATE_JUDICIAL_CHECK"] = "STATE_JUDICIAL_CHECK";
    AgFinancingFilesContext["REQUEST"] = "REQUEST";
    AgFinancingFilesContext["PESQUISA_SERASA"] = "PESQUISA_SERASA";
    AgFinancingFilesContext["DOCUMENTS"] = "DOCUMENTS";
    AgFinancingFilesContext["CPR"] = "CPR";
    AgFinancingFilesContext["CONTRACT_DRAFT_DOCUMENTS"] = "CONTRACT_DRAFT_DOCUMENTS";
    AgFinancingFilesContext["AMENDMENT_DOCUMENTS"] = "AMENDMENT_DOCUMENTS";
    AgFinancingFilesContext["AMENDMENT_SIGN_DOCUMENTS"] = "AMENDMENT_SIGN_DOCUMENTS";
    AgFinancingFilesContext["SIGNED_CONTRACT_DOCUMENTS"] = "SIGNED_CONTRACT_DOCUMENTS";
    AgFinancingFilesContext["PATRIMONY"] = "PATRIMONY";
})(AgFinancingFilesContext = exports.AgFinancingFilesContext || (exports.AgFinancingFilesContext = {}));
var AgFinancingFileStatus;
(function (AgFinancingFileStatus) {
    AgFinancingFileStatus["SENT"] = "SENT";
    AgFinancingFileStatus["APPROVED"] = "APPROVED";
    AgFinancingFileStatus["DENIED"] = "DENIED";
})(AgFinancingFileStatus = exports.AgFinancingFileStatus || (exports.AgFinancingFileStatus = {}));
var AgFinancingPhase2Status;
(function (AgFinancingPhase2Status) {
    AgFinancingPhase2Status["APPROVED"] = "APPROVED";
    AgFinancingPhase2Status["DENIED"] = "DENIED";
    AgFinancingPhase2Status["IN_PROGRESS"] = "IN_PROGRESS";
    AgFinancingPhase2Status["NOT_STARTED"] = "NOT_STARTED";
    AgFinancingPhase2Status["ON_HOLD"] = "ON_HOLD";
    AgFinancingPhase2Status["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
    AgFinancingPhase2Status["PENDING_RESTART"] = "PENDING_RESTART";
    AgFinancingPhase2Status["WAITING_COMMITTEE_DECISION"] = "WAITING_COMMITTEE_DECISION";
    AgFinancingPhase2Status["AWAITING_COMMERCIAL_DEAL"] = "AWAITING_COMMERCIAL_DEAL";
})(AgFinancingPhase2Status = exports.AgFinancingPhase2Status || (exports.AgFinancingPhase2Status = {}));
var AgFinancingPhase3Status;
(function (AgFinancingPhase3Status) {
    AgFinancingPhase3Status["IN_PROGRESS"] = "IN_PROGRESS";
    AgFinancingPhase3Status["APPROVED"] = "APPROVED";
    AgFinancingPhase3Status["DENIED"] = "DENIED";
    AgFinancingPhase3Status["ON_HOLD"] = "ON_HOLD";
})(AgFinancingPhase3Status = exports.AgFinancingPhase3Status || (exports.AgFinancingPhase3Status = {}));
var AgFinancingPhase4Status;
(function (AgFinancingPhase4Status) {
    AgFinancingPhase4Status["AWAITING_ASSIGNMENT"] = "AWAITING_ASSIGNMENT";
    AgFinancingPhase4Status["ASSIGNED_TO_FUND"] = "ASSIGNED_TO_FUND";
    AgFinancingPhase4Status["RECEIVED_BY_FUND"] = "RECEIVED_BY_FUND";
    AgFinancingPhase4Status["AWAITING_MANAGER_APPROVAL"] = "AWAITING_MANAGER_APPROVAL";
    AgFinancingPhase4Status["SUBMITTED_MINUTA"] = "SUBMITTED_MINUTA";
    AgFinancingPhase4Status["DENIED"] = "DENIED";
    AgFinancingPhase4Status["ON_HOLD"] = "ON_HOLD";
})(AgFinancingPhase4Status = exports.AgFinancingPhase4Status || (exports.AgFinancingPhase4Status = {}));
var AgFinancingPhases;
(function (AgFinancingPhases) {
    AgFinancingPhases["PHASE_1"] = "PHASE_1";
    AgFinancingPhases["PHASE_2"] = "PHASE_2";
    AgFinancingPhases["PHASE_3"] = "PHASE_3";
    AgFinancingPhases["PHASE_4"] = "PHASE_4";
})(AgFinancingPhases = exports.AgFinancingPhases || (exports.AgFinancingPhases = {}));
var AgFinancingPhaseStatus;
(function (AgFinancingPhaseStatus) {
    AgFinancingPhaseStatus["NOT_STARTED"] = "NOT_STARTED";
    AgFinancingPhaseStatus["CLEAR"] = "CLEAR";
    AgFinancingPhaseStatus["DENIED"] = "DENIED";
    AgFinancingPhaseStatus["AWAITING_MANAGER_APPROVAL"] = "AWAITING_MANAGER_APPROVAL";
    AgFinancingPhaseStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(AgFinancingPhaseStatus = exports.AgFinancingPhaseStatus || (exports.AgFinancingPhaseStatus = {}));
var AgFinancingPolls;
(function (AgFinancingPolls) {
    AgFinancingPolls["NEW_OPPORTUNITIES"] = "NEW_OPPORTUNITIES";
    AgFinancingPolls["CAN_RESTART_PHASE2"] = "CAN_RESTART_PHASE2";
    AgFinancingPolls["SALESFORCE_DOCUMENTS"] = "SALESFORCE_DOCUMENTS";
    AgFinancingPolls["PROCESS_INFO"] = "PROCESS_INFO";
    AgFinancingPolls["CHATTER"] = "CHATTER";
    AgFinancingPolls["GUARANTORS"] = "GUARANTORS";
    AgFinancingPolls["OPP_STAGE_VALIDATING"] = "OPP_STAGE_VALIDATING";
    AgFinancingPolls["PENDING_CONTRACT_VALIDATION"] = "PENDING_CONTRACT_VALIDATION";
    AgFinancingPolls["SYNC_VISIT_APPLICATIONS"] = "SYNC_VISIT_APPLICATIONS";
})(AgFinancingPolls = exports.AgFinancingPolls || (exports.AgFinancingPolls = {}));
var AgFinancingRequestStatuses;
(function (AgFinancingRequestStatuses) {
    AgFinancingRequestStatuses["SENT"] = "SENT";
    AgFinancingRequestStatuses["OVERDUE"] = "OVERDUE";
    AgFinancingRequestStatuses["SUBMISSION_RECEIVED"] = "SUBMISSION_RECEIVED";
    AgFinancingRequestStatuses["NEEDS_REVISION"] = "NEEDS_REVISION";
    AgFinancingRequestStatuses["APPROVED"] = "APPROVED";
    AgFinancingRequestStatuses["DENIED"] = "DENIED";
    AgFinancingRequestStatuses["DELETED"] = "DELETED";
})(AgFinancingRequestStatuses = exports.AgFinancingRequestStatuses || (exports.AgFinancingRequestStatuses = {}));
var AgMatriculaDetailType;
(function (AgMatriculaDetailType) {
    AgMatriculaDetailType["LEGAL"] = "LEGAL";
    AgMatriculaDetailType["FIELD_MONITORING"] = "FIELD_MONITORING";
})(AgMatriculaDetailType = exports.AgMatriculaDetailType || (exports.AgMatriculaDetailType = {}));
var AgStateName;
(function (AgStateName) {
    AgStateName["PHASE_1"] = "PHASE_1";
    AgStateName["P1_NEW"] = "P1_NEW";
    AgStateName["P1_IN_PROGRESS"] = "P1_IN_PROGRESS";
    AgStateName["P1_CM_APPROVAL"] = "P1_CM_APPROVAL";
    AgStateName["P1_COMPLETE"] = "P1_COMPLETE";
    AgStateName["AWAITING_COMMERCIAL_DEAL"] = "AWAITING_COMMERCIAL_DEAL";
    AgStateName["ON_HOLD"] = "ON_HOLD";
    AgStateName["PHASE_2"] = "PHASE_2";
    AgStateName["P2_PENDING_ACTIVATION"] = "P2_PENDING_ACTIVATION";
    AgStateName["P2_PENDING_RESTART"] = "P2_PENDING_RESTART";
    AgStateName["P2_IN_ANALYSIS"] = "P2_IN_ANALYSIS";
    AgStateName["P2_CM_APPROVAL"] = "P2_CM_APPROVAL";
    AgStateName["P2_LUCHESI"] = "P2_LUCHESI";
    AgStateName["P2_LUCHESI_NEW"] = "P2_LUCHESI_NEW";
    AgStateName["P2_LUCHESI_IN_PROGRESS"] = "P2_LUCHESI_IN_PROGRESS";
    AgStateName["P2_LUCHESI_ON_HOLD"] = "P2_LUCHESI_ON_HOLD";
    AgStateName["P2_LUCHESI_COMPLETE"] = "P2_LUCHESI_COMPLETE";
    AgStateName["P2_LUCHESI_CM_APPROVAL"] = "P2_LUCHESI_CM_APPROVAL";
    AgStateName["P2_LUCHESI_APPROVED"] = "P2_LUCHESI_APPROVED";
    AgStateName["P2_LUCHESI_REJECTED"] = "P2_LUCHESI_REJECTED";
    AgStateName["P2_FLC"] = "P2_FLC";
    AgStateName["P2_FLC_NEW"] = "P2_FLC_NEW";
    AgStateName["P2_FLC_IN_PROGRESS"] = "P2_FLC_IN_PROGRESS";
    AgStateName["P2_FLC_ON_HOLD"] = "P2_FLC_ON_HOLD";
    AgStateName["P2_FLC_COMPLETE"] = "P2_FLC_COMPLETE";
    AgStateName["P2_FLC_CM_APPROVAL"] = "P2_FLC_CM_APPROVAL";
    AgStateName["P2_FLC_APPROVED"] = "P2_FLC_APPROVED";
    AgStateName["P2_FLC_REJECTED"] = "P2_FLC_REJECTED";
    AgStateName["P2_CREDIT_APPROVAL"] = "P2_CREDIT_APPROVAL";
    AgStateName["P2_CREDIT_APPROVAL_IN_PROGRESS"] = "P2_CREDIT_APPROVAL_IN_PROGRESS";
    AgStateName["P2_CREDIT_APPROVAL_CREDIT_ANALYST_APPROVED"] = "P2_CREDIT_APPROVAL_CREDIT_ANALYST_APPROVED";
    AgStateName["P2_CREDIT_APPROVAL_CREDIT_SUPERVISOR_APPROVED"] = "P2_CREDIT_APPROVAL_CREDIT_SUPERVISOR_APPROVED";
    AgStateName["P2_CREDIT_APPROVAL_CREDIT_MANAGER_APPROVED"] = "P2_CREDIT_APPROVAL_CREDIT_MANAGER_APPROVED";
    AgStateName["P2_CREDIT_APPROVAL_COMMERCIAL_DIRECTOR_APPROVED"] = "P2_CREDIT_APPROVAL_COMMERCIAL_DIRECTOR_APPROVED";
    AgStateName["P2_CREDIT_APPROVAL_FINANCE_DIRECTOR_APPROVED"] = "P2_CREDIT_APPROVAL_FINANCE_DIRECTOR_APPROVED";
    AgStateName["P2_CREDIT_APPROVAL_DENIED"] = "P2_CREDIT_APPROVAL_DENIED";
    AgStateName["P2_CREDIT_APPROVAL_WAITING_CREDIT_MANAGER_APPROVAL"] = "P2_CREDIT_APPROVAL_WAITING_CREDIT_MANAGER_APPROVAL";
    AgStateName["P2_TERRAMAGNA"] = "P2_TERRAMAGNA";
    AgStateName["P2_TERRAMAGNA_NEW"] = "P2_TERRAMAGNA_NEW";
    AgStateName["P2_TERRAMAGNA_IN_PROGRESS"] = "P2_TERRAMAGNA_IN_PROGRESS";
    AgStateName["P2_TERRAMAGNA_ON_HOLD"] = "P2_TERRAMAGNA_ON_HOLD";
    AgStateName["P2_TERRAMAGNA_COMPLETE"] = "P2_TERRAMAGNA_COMPLETE";
    AgStateName["P2_TERRAMAGNA_CM_APPROVAL"] = "P2_TERRAMAGNA_CM_APPROVAL";
    AgStateName["P2_AWAITING_COMMERCIAL_DEAL"] = "P2_AWAITING_COMMERCIAL_DEAL";
    AgStateName["P2_AWAITING_COMMERCIAL_DEAL_AWAITING"] = "P2_AWAITING_COMMERCIAL_DEAL_AWAITING";
    AgStateName["P2_AWAITING_COMMERCIAL_DEAL_COMPLETE"] = "P2_AWAITING_COMMERCIAL_DEAL_COMPLETE";
    AgStateName["P2_APPROVED"] = "P2_APPROVED";
    AgStateName["P2_REJECTED"] = "P2_REJECTED";
    AgStateName["P2_ON_HOLD"] = "P2_ON_HOLD";
    AgStateName["PHASE_3"] = "PHASE_3";
    AgStateName["P3_GENERATE_MINUTA"] = "P3_GENERATE_MINUTA";
    AgStateName["P3_GENERATE_AMENDMENT"] = "P3_GENERATE_AMENDMENT";
    AgStateName["P3_AWAITING_MANAGER_SIGNATURE"] = "P3_AWAITING_MANAGER_SIGNATURE";
    AgStateName["P3_AWAITING_DIGITAL_SIGNATURES"] = "P3_AWAITING_DIGITAL_SIGNATURES";
    AgStateName["P3_MINUTA_REGISTERING"] = "P3_MINUTA_REGISTERING";
    AgStateName["P3_MINUTA_VALIDATING"] = "P3_MINUTA_VALIDATING";
    AgStateName["P3_MINUTA_VALIDATING_CA"] = "P3_MINUTA_VALIDATING_CA";
    AgStateName["P3_MINUTA_VALIDATING_CM"] = "P3_MINUTA_VALIDATING_CM";
    AgStateName["P3_ON_HOLD"] = "P3_ON_HOLD";
    AgStateName["AWAITING_CONTRACT_VALIDATION"] = "AWAITING_CONTRACT_VALIDATION";
    AgStateName["PHASE_4"] = "PHASE_4";
    AgStateName["P4_AWAITING_ASSIGNMENT"] = "P4_AWAITING_ASSIGNMENT";
    AgStateName["P4_ASSIGNED_TO_FUND"] = "P4_ASSIGNED_TO_FUND";
    AgStateName["P4_RECEIVED_BY_FUND"] = "P4_RECEIVED_BY_FUND";
    AgStateName["P4_GROUPED"] = "P4_GROUPED";
    AgStateName["P4_GROUP_AWAITING_ASSIGNMENT"] = "P4_GROUP_AWAITING_ASSIGNMENT";
    AgStateName["P4_GROUP_ASSIGNED_TO_FUND"] = "P4_GROUP_ASSIGNED_TO_FUND";
    AgStateName["P4_GROUP_RECEIVED_BY_FUND"] = "P4_GROUP_RECEIVED_BY_FUND";
    AgStateName["P4_GROUP_AWAITING_MANAGER_APPROVAL"] = "P4_GROUP_AWAITING_MANAGER_APPROVAL";
    AgStateName["P4_GROUP_MANAGER_DENIED"] = "P4_GROUP_MANAGER_DENIED";
    AgStateName["P4_SUBMITTED_MINUTA"] = "P4_SUBMITTED_MINUTA";
    AgStateName["P4_ON_HOLD"] = "P4_ON_HOLD";
    AgStateName["CLOSED"] = "CLOSED";
    AgStateName["CANCELLED"] = "CANCELLED";
})(AgStateName = exports.AgStateName || (exports.AgStateName = {}));
var AnalysisStatus;
(function (AnalysisStatus) {
    AnalysisStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AnalysisStatus["SENT"] = "SENT";
    AnalysisStatus["APPROVED"] = "APPROVED";
})(AnalysisStatus = exports.AnalysisStatus || (exports.AnalysisStatus = {}));
var Application;
(function (Application) {
    Application["TRUCKING"] = "TRUCKING";
    Application["DRIVER"] = "DRIVER";
    Application["SHIPPING"] = "SHIPPING";
    Application["GROWER_MARKETPLACE"] = "GROWER_MARKETPLACE";
    Application["BUYER_MARKETPLACE"] = "BUYER_MARKETPLACE";
    Application["BARTER"] = "BARTER";
    Application["BRAZIL_GROWER"] = "BRAZIL_GROWER";
})(Application = exports.Application || (exports.Application = {}));
var ApplicationUserExperience;
(function (ApplicationUserExperience) {
    ApplicationUserExperience["MARKETPLACE_GROWER"] = "MARKETPLACE_GROWER";
    ApplicationUserExperience["MARKETPLACE_BUYER"] = "MARKETPLACE_BUYER";
    ApplicationUserExperience["MARKETPLACE_GMA"] = "MARKETPLACE_GMA";
    ApplicationUserExperience["MARKETPLACE_GROWER_ADMIN"] = "MARKETPLACE_GROWER_ADMIN";
    ApplicationUserExperience["TRUCKING_CARRIER"] = "TRUCKING_CARRIER";
    ApplicationUserExperience["TRUCKING_DRIVER"] = "TRUCKING_DRIVER";
    ApplicationUserExperience["FINANCING_APPLICANT"] = "FINANCING_APPLICANT";
    ApplicationUserExperience["FINANCING_MULTIPLIER"] = "FINANCING_MULTIPLIER";
    ApplicationUserExperience["FINANCING_ADMIN"] = "FINANCING_ADMIN";
    ApplicationUserExperience["FINANCING_BRAZIL_GROWER"] = "FINANCING_BRAZIL_GROWER";
    ApplicationUserExperience["TRANSPORT_SHIPPER"] = "TRANSPORT_SHIPPER";
    ApplicationUserExperience["SHIPPING_SHIPPER"] = "SHIPPING_SHIPPER";
    ApplicationUserExperience["FIELDS_GROWER"] = "FIELDS_GROWER";
})(ApplicationUserExperience = exports.ApplicationUserExperience || (exports.ApplicationUserExperience = {}));
var ARSubdivisionAbbreviation;
(function (ARSubdivisionAbbreviation) {
    ARSubdivisionAbbreviation["B"] = "B";
    ARSubdivisionAbbreviation["K"] = "K";
    ARSubdivisionAbbreviation["H"] = "H";
    ARSubdivisionAbbreviation["U"] = "U";
    ARSubdivisionAbbreviation["X"] = "X";
    ARSubdivisionAbbreviation["W"] = "W";
    ARSubdivisionAbbreviation["E"] = "E";
    ARSubdivisionAbbreviation["P"] = "P";
    ARSubdivisionAbbreviation["Y"] = "Y";
    ARSubdivisionAbbreviation["L"] = "L";
    ARSubdivisionAbbreviation["F"] = "F";
    ARSubdivisionAbbreviation["M"] = "M";
    ARSubdivisionAbbreviation["N"] = "N";
    ARSubdivisionAbbreviation["Q"] = "Q";
    ARSubdivisionAbbreviation["R"] = "R";
    ARSubdivisionAbbreviation["A"] = "A";
    ARSubdivisionAbbreviation["J"] = "J";
    ARSubdivisionAbbreviation["D"] = "D";
    ARSubdivisionAbbreviation["Z"] = "Z";
    ARSubdivisionAbbreviation["S"] = "S";
    ARSubdivisionAbbreviation["G"] = "G";
    ARSubdivisionAbbreviation["V"] = "V";
    ARSubdivisionAbbreviation["T"] = "T";
})(ARSubdivisionAbbreviation = exports.ARSubdivisionAbbreviation || (exports.ARSubdivisionAbbreviation = {}));
var BacenStatus;
(function (BacenStatus) {
    BacenStatus["CLEARED"] = "CLEARED";
    BacenStatus["FAILED"] = "FAILED";
    BacenStatus["UNRESOLVED"] = "UNRESOLVED";
    BacenStatus["GET_SCR_DATA"] = "GET_SCR_DATA";
})(BacenStatus = exports.BacenStatus || (exports.BacenStatus = {}));
var BackgroundCheckDisplayStatus;
(function (BackgroundCheckDisplayStatus) {
    BackgroundCheckDisplayStatus["IN_PROGRESS"] = "IN_PROGRESS";
    BackgroundCheckDisplayStatus["CLEARED"] = "CLEARED";
    BackgroundCheckDisplayStatus["FAILED"] = "FAILED";
    BackgroundCheckDisplayStatus["UNRESOLVED"] = "UNRESOLVED";
    BackgroundCheckDisplayStatus["EXPIRED"] = "EXPIRED";
})(BackgroundCheckDisplayStatus = exports.BackgroundCheckDisplayStatus || (exports.BackgroundCheckDisplayStatus = {}));
var BackgroundCheckStatus;
(function (BackgroundCheckStatus) {
    BackgroundCheckStatus["PROCESSING"] = "PROCESSING";
    BackgroundCheckStatus["COMPLETE"] = "COMPLETE";
    BackgroundCheckStatus["EXPIRED"] = "EXPIRED";
})(BackgroundCheckStatus = exports.BackgroundCheckStatus || (exports.BackgroundCheckStatus = {}));
var BackgroundCheckStepEventType;
(function (BackgroundCheckStepEventType) {
    BackgroundCheckStepEventType["ACCEPTED_DECISION"] = "ACCEPTED_DECISION";
    BackgroundCheckStepEventType["OVERRODE_DECISION_FAIL"] = "OVERRODE_DECISION_FAIL";
    BackgroundCheckStepEventType["OVERRODE_DECISION_PASS"] = "OVERRODE_DECISION_PASS";
    BackgroundCheckStepEventType["RETRIED"] = "RETRIED";
    BackgroundCheckStepEventType["STARTED_PROCESSING"] = "STARTED_PROCESSING";
    BackgroundCheckStepEventType["SYSTEM_ACCEPTED_DECISION"] = "SYSTEM_ACCEPTED_DECISION";
    BackgroundCheckStepEventType["SYSTEM_ERRORED"] = "SYSTEM_ERRORED";
    BackgroundCheckStepEventType["SYSTEM_TENTATIVELY_PASSED"] = "SYSTEM_TENTATIVELY_PASSED";
    BackgroundCheckStepEventType["SYSTEM_PASSED"] = "SYSTEM_PASSED";
    BackgroundCheckStepEventType["SYSTEM_TENTATIVELY_FAILED"] = "SYSTEM_TENTATIVELY_FAILED";
})(BackgroundCheckStepEventType = exports.BackgroundCheckStepEventType || (exports.BackgroundCheckStepEventType = {}));
var BackgroundCheckStepStatus;
(function (BackgroundCheckStepStatus) {
    BackgroundCheckStepStatus["NOT_STARTED"] = "NOT_STARTED";
    BackgroundCheckStepStatus["PROCESSING"] = "PROCESSING";
    BackgroundCheckStepStatus["PASSED_TENTATIVE"] = "PASSED_TENTATIVE";
    BackgroundCheckStepStatus["FAILED_TENTATIVE"] = "FAILED_TENTATIVE";
    BackgroundCheckStepStatus["PASSED"] = "PASSED";
    BackgroundCheckStepStatus["FAILED"] = "FAILED";
    BackgroundCheckStepStatus["SYSTEM_ERROR"] = "SYSTEM_ERROR";
})(BackgroundCheckStepStatus = exports.BackgroundCheckStepStatus || (exports.BackgroundCheckStepStatus = {}));
var BackgroundCheckStepType;
(function (BackgroundCheckStepType) {
    BackgroundCheckStepType["FORCED_LABOR"] = "FORCED_LABOR";
    BackgroundCheckStepType["NEGATIVE_DEBT"] = "NEGATIVE_DEBT";
    BackgroundCheckStepType["EMBARGO"] = "EMBARGO";
})(BackgroundCheckStepType = exports.BackgroundCheckStepType || (exports.BackgroundCheckStepType = {}));
var BackgroundCheckSupportingDocumentType;
(function (BackgroundCheckSupportingDocumentType) {
    BackgroundCheckSupportingDocumentType["FORCED_LABOR_LIST"] = "FORCED_LABOR_LIST";
    BackgroundCheckSupportingDocumentType["NEGATIVE_DEBT_CERTIFICATE"] = "NEGATIVE_DEBT_CERTIFICATE";
    BackgroundCheckSupportingDocumentType["EMBARGO_CERTIFICATE"] = "EMBARGO_CERTIFICATE";
    BackgroundCheckSupportingDocumentType["CPA_DECISION_SHEET_SNAPSHOT"] = "CPA_DECISION_SHEET_SNAPSHOT";
})(BackgroundCheckSupportingDocumentType = exports.BackgroundCheckSupportingDocumentType || (exports.BackgroundCheckSupportingDocumentType = {}));
var BackgroundCheckUpdateEntityType;
(function (BackgroundCheckUpdateEntityType) {
    BackgroundCheckUpdateEntityType["CONTACT"] = "CONTACT";
    BackgroundCheckUpdateEntityType["ACCOUNT"] = "ACCOUNT";
})(BackgroundCheckUpdateEntityType = exports.BackgroundCheckUpdateEntityType || (exports.BackgroundCheckUpdateEntityType = {}));
var BRState;
(function (BRState) {
    BRState["SAO_PALO"] = "SAO_PALO";
    BRState["MINAS_GERAIS"] = "MINAS_GERAIS";
    BRState["RIO_DE_JANEIRO"] = "RIO_DE_JANEIRO";
    BRState["BAHIA"] = "BAHIA";
    BRState["RIO_GRANDE"] = "RIO_GRANDE";
    BRState["PARANA"] = "PARANA";
    BRState["PERNAMBUCO"] = "PERNAMBUCO";
    BRState["CEARA"] = "CEARA";
    BRState["PARA"] = "PARA";
    BRState["MARANHAO"] = "MARANHAO";
    BRState["SANTA_CATARINA"] = "SANTA_CATARINA";
    BRState["GOIAS"] = "GOIAS";
    BRState["PARAIBA"] = "PARAIBA";
    BRState["ESPIRITO_SANTO"] = "ESPIRITO_SANTO";
    BRState["AMAZONAS"] = "AMAZONAS";
    BRState["RIO_GRANDE_DO_NORTRE"] = "RIO_GRANDE_DO_NORTRE";
    BRState["ALAGOAS"] = "ALAGOAS";
    BRState["MATO_GROSSO"] = "MATO_GROSSO";
    BRState["PIAUI"] = "PIAUI";
    BRState["DISTRITO_FEDERAL"] = "DISTRITO_FEDERAL";
    BRState["MATO_GROSSO_DO_SUL"] = "MATO_GROSSO_DO_SUL";
    BRState["SERGIPE"] = "SERGIPE";
    BRState["RONDONIA"] = "RONDONIA";
    BRState["TOCANTINS"] = "TOCANTINS";
    BRState["ACRE"] = "ACRE";
    BRState["AMAPA"] = "AMAPA";
    BRState["RORAIMA"] = "RORAIMA";
})(BRState = exports.BRState || (exports.BRState = {}));
var BRSubdivisionAbbreviation;
(function (BRSubdivisionAbbreviation) {
    BRSubdivisionAbbreviation["DF"] = "DF";
    BRSubdivisionAbbreviation["AC"] = "AC";
    BRSubdivisionAbbreviation["AL"] = "AL";
    BRSubdivisionAbbreviation["AP"] = "AP";
    BRSubdivisionAbbreviation["AM"] = "AM";
    BRSubdivisionAbbreviation["BA"] = "BA";
    BRSubdivisionAbbreviation["CE"] = "CE";
    BRSubdivisionAbbreviation["ES"] = "ES";
    BRSubdivisionAbbreviation["GO"] = "GO";
    BRSubdivisionAbbreviation["MA"] = "MA";
    BRSubdivisionAbbreviation["MT"] = "MT";
    BRSubdivisionAbbreviation["MS"] = "MS";
    BRSubdivisionAbbreviation["MG"] = "MG";
    BRSubdivisionAbbreviation["PA"] = "PA";
    BRSubdivisionAbbreviation["PB"] = "PB";
    BRSubdivisionAbbreviation["PR"] = "PR";
    BRSubdivisionAbbreviation["PE"] = "PE";
    BRSubdivisionAbbreviation["PI"] = "PI";
    BRSubdivisionAbbreviation["RJ"] = "RJ";
    BRSubdivisionAbbreviation["RN"] = "RN";
    BRSubdivisionAbbreviation["RS"] = "RS";
    BRSubdivisionAbbreviation["RO"] = "RO";
    BRSubdivisionAbbreviation["RR"] = "RR";
    BRSubdivisionAbbreviation["SC"] = "SC";
    BRSubdivisionAbbreviation["SP"] = "SP";
    BRSubdivisionAbbreviation["SE"] = "SE";
    BRSubdivisionAbbreviation["TO"] = "TO";
})(BRSubdivisionAbbreviation = exports.BRSubdivisionAbbreviation || (exports.BRSubdivisionAbbreviation = {}));
var BusinessAccountType;
(function (BusinessAccountType) {
    BusinessAccountType["GROWER"] = "GROWER";
    BusinessAccountType["BUYER"] = "BUYER";
    BusinessAccountType["CARRIER"] = "CARRIER";
    BusinessAccountType["SHIPPER"] = "SHIPPER";
    BusinessAccountType["GMA"] = "GMA";
})(BusinessAccountType = exports.BusinessAccountType || (exports.BusinessAccountType = {}));
var CarrierDriverOrderByInput;
(function (CarrierDriverOrderByInput) {
    CarrierDriverOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    CarrierDriverOrderByInput["createdAt_DESC"] = "createdAt_DESC";
    CarrierDriverOrderByInput["firstName_ASC"] = "firstName_ASC";
    CarrierDriverOrderByInput["firstName_DESC"] = "firstName_DESC";
})(CarrierDriverOrderByInput = exports.CarrierDriverOrderByInput || (exports.CarrierDriverOrderByInput = {}));
var CarrierOrderStatus;
(function (CarrierOrderStatus) {
    CarrierOrderStatus["ACTIVE"] = "ACTIVE";
    CarrierOrderStatus["SUBMITTED"] = "SUBMITTED";
    CarrierOrderStatus["PENDING"] = "PENDING";
    CarrierOrderStatus["CANCELED"] = "CANCELED";
})(CarrierOrderStatus = exports.CarrierOrderStatus || (exports.CarrierOrderStatus = {}));
var ChatChannelOrder;
(function (ChatChannelOrder) {
    ChatChannelOrder["CHAT_MESSAGE_CREATED_AT"] = "CHAT_MESSAGE_CREATED_AT";
})(ChatChannelOrder = exports.ChatChannelOrder || (exports.ChatChannelOrder = {}));
var ChatChannelStatus;
(function (ChatChannelStatus) {
    ChatChannelStatus["READ"] = "READ";
    ChatChannelStatus["UNREAD"] = "UNREAD";
})(ChatChannelStatus = exports.ChatChannelStatus || (exports.ChatChannelStatus = {}));
var ChatChannelType;
(function (ChatChannelType) {
    ChatChannelType["PRIVATE"] = "PRIVATE";
    ChatChannelType["PUBLIC"] = "PUBLIC";
})(ChatChannelType = exports.ChatChannelType || (exports.ChatChannelType = {}));
var ChatMessageType;
(function (ChatMessageType) {
    ChatMessageType["MEDIA"] = "MEDIA";
    ChatMessageType["TEXT"] = "TEXT";
})(ChatMessageType = exports.ChatMessageType || (exports.ChatMessageType = {}));
var CollateralType;
(function (CollateralType) {
    CollateralType["CPR"] = "CPR";
    CollateralType["CPRF"] = "CPRF";
    CollateralType["PROMISSORY_NOTE"] = "PROMISSORY_NOTE";
    CollateralType["FIDUCIARY_SALE"] = "FIDUCIARY_SALE";
    CollateralType["LETTER_OF_GUARANTEE"] = "LETTER_OF_GUARANTEE";
    CollateralType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    CollateralType["NOT_FOUND"] = "NOT_FOUND";
})(CollateralType = exports.CollateralType || (exports.CollateralType = {}));
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["WAITING_DRAFT"] = "WAITING_DRAFT";
    ContractStatus["DRAFT_SENT_TO_COMMERCIAL"] = "DRAFT_SENT_TO_COMMERCIAL";
    ContractStatus["REVIEWING_SIGNED_DOCUMENTS"] = "REVIEWING_SIGNED_DOCUMENTS";
    ContractStatus["SIGNED_DOCUMENTS_APPROVED"] = "SIGNED_DOCUMENTS_APPROVED";
    ContractStatus["SIGNED_DOCUMENTS_DENIED"] = "SIGNED_DOCUMENTS_DENIED";
    ContractStatus["SIGNED_DOCUMENTS_SENT_TO_CREDIT_TEAM"] = "SIGNED_DOCUMENTS_SENT_TO_CREDIT_TEAM";
    ContractStatus["SIGNED_DOCUMENTS_SENT_TO_CREDIT_MANAGER"] = "SIGNED_DOCUMENTS_SENT_TO_CREDIT_MANAGER";
    ContractStatus["CREATING_AMENDMENT"] = "CREATING_AMENDMENT";
    ContractStatus["WAITING_DIGITAL_SIGNATURE"] = "WAITING_DIGITAL_SIGNATURE";
    ContractStatus["WAITING_PHYSICAL_SIGNATURE"] = "WAITING_PHYSICAL_SIGNATURE";
})(ContractStatus = exports.ContractStatus || (exports.ContractStatus = {}));
var CornVariety;
(function (CornVariety) {
    CornVariety["ANY"] = "ANY";
    CornVariety["OTHER"] = "OTHER";
    CornVariety["TA524_28"] = "TA524_28";
    CornVariety["TA548_28"] = "TA548_28";
    CornVariety["TA567_28"] = "TA567_28";
    CornVariety["TA568_22DP"] = "TA568_22DP";
    CornVariety["TA583_00"] = "TA583_00";
    CornVariety["TA583_28_RIB"] = "TA583_28_RIB";
    CornVariety["TA588_22DP"] = "TA588_22DP";
    CornVariety["TA590_00"] = "TA590_00";
    CornVariety["TA598_22DP"] = "TA598_22DP";
    CornVariety["TA598_02"] = "TA598_02";
    CornVariety["TA618_22DP"] = "TA618_22DP";
    CornVariety["TA618_28_RIB"] = "TA618_28_RIB";
    CornVariety["TA683_22DP"] = "TA683_22DP";
    CornVariety["TA683_00"] = "TA683_00";
    CornVariety["TA736_00"] = "TA736_00";
    CornVariety["TA736_22DP"] = "TA736_22DP";
    CornVariety["TA736_02"] = "TA736_02";
    CornVariety["TA736_28_RIB"] = "TA736_28_RIB";
    CornVariety["TA744_00"] = "TA744_00";
    CornVariety["TA744_22DP"] = "TA744_22DP";
    CornVariety["TA768_28"] = "TA768_28";
    CornVariety["TA765_00"] = "TA765_00";
    CornVariety["TA765_30"] = "TA765_30";
    CornVariety["TA766_33EZ"] = "TA766_33EZ";
    CornVariety["TA774_22DP"] = "TA774_22DP";
})(CornVariety = exports.CornVariety || (exports.CornVariety = {}));
var CottonVariety;
(function (CottonVariety) {
    CottonVariety["AMUA48"] = "AMUA48";
    CottonVariety["ANY"] = "ANY";
    CottonVariety["NG5711B3XF"] = "NG5711B3XF";
    CottonVariety["NG3780B2XF"] = "NG3780B2XF";
    CottonVariety["NG4777B2XF"] = "NG4777B2XF";
    CottonVariety["NG3406B2XF"] = "NG3406B2XF";
    CottonVariety["NG3517B2XF"] = "NG3517B2XF";
    CottonVariety["NG3522B2XF"] = "NG3522B2XF";
    CottonVariety["NG3699B2XF"] = "NG3699B2XF";
    CottonVariety["NG4601B2XF"] = "NG4601B2XF";
    CottonVariety["NG5007B2XF"] = "NG5007B2XF";
    CottonVariety["NG3405B2XF"] = "NG3405B2XF";
    CottonVariety["NG4545B2XF"] = "NG4545B2XF";
    CottonVariety["NG4689B2XF"] = "NG4689B2XF";
    CottonVariety["NG4792XF"] = "NG4792XF";
    CottonVariety["NG3500XF"] = "NG3500XF";
    CottonVariety["NG3640XF"] = "NG3640XF";
    CottonVariety["NG1511B2RF"] = "NG1511B2RF";
    CottonVariety["NG3306B2RF"] = "NG3306B2RF";
    CottonVariety["NG4012B2RF"] = "NG4012B2RF";
    CottonVariety["OTHER"] = "OTHER";
})(CottonVariety = exports.CottonVariety || (exports.CottonVariety = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "US";
    CountryCode["AR"] = "AR";
    CountryCode["BR"] = "BR";
    CountryCode["MX"] = "MX";
    CountryCode["CA"] = "CA";
    CountryCode["BE"] = "BE";
    CountryCode["DE"] = "DE";
    CountryCode["FR"] = "FR";
    CountryCode["IT"] = "IT";
    CountryCode["HU"] = "HU";
    CountryCode["NL"] = "NL";
    CountryCode["AT"] = "AT";
    CountryCode["PL"] = "PL";
    CountryCode["PT"] = "PT";
    CountryCode["FI"] = "FI";
    CountryCode["SE"] = "SE";
    CountryCode["GB"] = "GB";
    CountryCode["UA"] = "UA";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
var CprStatus;
(function (CprStatus) {
    CprStatus["NOT_SENT"] = "NOT_SENT";
    CprStatus["ON_HOLD"] = "ON_HOLD";
    CprStatus["SENT_BACK_FOR_REVISION"] = "SENT_BACK_FOR_REVISION";
    CprStatus["APPROVED"] = "APPROVED";
    CprStatus["DENIED"] = "DENIED";
})(CprStatus = exports.CprStatus || (exports.CprStatus = {}));
var CreditApprovalRoundStatus;
(function (CreditApprovalRoundStatus) {
    CreditApprovalRoundStatus["IN_PROGRESS"] = "IN_PROGRESS";
    CreditApprovalRoundStatus["COMPLETE"] = "COMPLETE";
})(CreditApprovalRoundStatus = exports.CreditApprovalRoundStatus || (exports.CreditApprovalRoundStatus = {}));
var CreditApprovalStepDecision;
(function (CreditApprovalStepDecision) {
    CreditApprovalStepDecision["APPROVED"] = "APPROVED";
    CreditApprovalStepDecision["DENIED"] = "DENIED";
})(CreditApprovalStepDecision = exports.CreditApprovalStepDecision || (exports.CreditApprovalStepDecision = {}));
var CreditApprovalStepStatus;
(function (CreditApprovalStepStatus) {
    CreditApprovalStepStatus["COMPLETE"] = "COMPLETE";
    CreditApprovalStepStatus["NOT_STARTED"] = "NOT_STARTED";
})(CreditApprovalStepStatus = exports.CreditApprovalStepStatus || (exports.CreditApprovalStepStatus = {}));
var CreditApprovalStepType;
(function (CreditApprovalStepType) {
    CreditApprovalStepType["CREDIT_ANALYST_APPROVAL"] = "CREDIT_ANALYST_APPROVAL";
    CreditApprovalStepType["CREDIT_SUPERVISOR_APPROVAL"] = "CREDIT_SUPERVISOR_APPROVAL";
    CreditApprovalStepType["CREDIT_MANAGER_APPROVAL"] = "CREDIT_MANAGER_APPROVAL";
    CreditApprovalStepType["COMMERCIAL_DIRECTOR_APPROVAL"] = "COMMERCIAL_DIRECTOR_APPROVAL";
    CreditApprovalStepType["FINANCE_DIRECTOR_APPROVAL"] = "FINANCE_DIRECTOR_APPROVAL";
})(CreditApprovalStepType = exports.CreditApprovalStepType || (exports.CreditApprovalStepType = {}));
var CreditConditional;
(function (CreditConditional) {
    CreditConditional["REAL_ESTATE_FIDUCIARY_ALIENATION"] = "REAL_ESTATE_FIDUCIARY_ALIENATION";
    CreditConditional["MORTGAGE"] = "MORTGAGE";
    CreditConditional["OVERCOLLATERAL_ABOVE_130_PERCENT"] = "OVERCOLLATERAL_ABOVE_130_PERCENT";
    CreditConditional["RESTRICTIONS_SETTLEMENT_BEFORE_DISBURSEMENT"] = "RESTRICTIONS_SETTLEMENT_BEFORE_DISBURSEMENT";
    CreditConditional["PREVIOUS_HARVEST_SETTLEMENT"] = "PREVIOUS_HARVEST_SETTLEMENT";
    CreditConditional["PIVOT_AREA_GUARANTEE"] = "PIVOT_AREA_GUARANTEE";
    CreditConditional["OWN_AREA_GUARANTEE"] = "OWN_AREA_GUARANTEE";
    CreditConditional["COLLECTION_VISIT"] = "COLLECTION_VISIT";
    CreditConditional["APPROVED_TRADING_CREDIT_ASSIGNMENT"] = "APPROVED_TRADING_CREDIT_ASSIGNMENT";
    CreditConditional["UPDATED_REGISTRATION"] = "UPDATED_REGISTRATION";
    CreditConditional["OTHER"] = "OTHER";
})(CreditConditional = exports.CreditConditional || (exports.CreditConditional = {}));
var CreditException;
(function (CreditException) {
    CreditException["EMBARGOES"] = "EMBARGOES";
    CreditException["PLEDGE_DEGREE"] = "PLEDGE_DEGREE";
    CreditException["WAIVER_OF_CONSENT"] = "WAIVER_OF_CONSENT";
    CreditException["CCV_WITH_TRADING_MANDATORY"] = "CCV_WITH_TRADING_MANDATORY";
    CreditException["COMMERCIAL_SKETCH"] = "COMMERCIAL_SKETCH";
    CreditException["PRICE_ADJUSTMENT"] = "PRICE_ADJUSTMENT";
    CreditException["AVERAGE_PRODUCTIVITY_ADJUSTMENT"] = "AVERAGE_PRODUCTIVITY_ADJUSTMENT";
    CreditException["FULL_LESSEE"] = "FULL_LESSEE";
    CreditException["TRADING_EXCEPTION"] = "TRADING_EXCEPTION";
    CreditException["OVERCOLLATERAL_REDUCTION"] = "OVERCOLLATERAL_REDUCTION";
    CreditException["LAWSUITS_OR_SERASA"] = "LAWSUITS_OR_SERASA";
    CreditException["COMMITMENT_ABOVE_POLITICS"] = "COMMITMENT_ABOVE_POLITICS";
    CreditException["EMBARGOED_AREAS"] = "EMBARGOED_AREAS";
    CreditException["SERASA_RECORDS"] = "SERASA_RECORDS";
    CreditException["SERASA_INJUNCTION"] = "SERASA_INJUNCTION";
    CreditException["LAWSUITS"] = "LAWSUITS";
    CreditException["OPEN_HARVEST_VALIDATION"] = "OPEN_HARVEST_VALIDATION";
    CreditException["UNAPPROVED_TRADING_CREDIT"] = "UNAPPROVED_TRADING_CREDIT";
    CreditException["UNDELIVERED_CREDIT_ASSIGNMENT"] = "UNDELIVERED_CREDIT_ASSIGNMENT";
    CreditException["OUTDATED_REGISTRATION"] = "OUTDATED_REGISTRATION";
    CreditException["REGISTRATION_WITH_LAWSUITS"] = "REGISTRATION_WITH_LAWSUITS";
    CreditException["IRREGULAR_CAR"] = "IRREGULAR_CAR";
    CreditException["OTHER"] = "OTHER";
})(CreditException = exports.CreditException || (exports.CreditException = {}));
var Crop;
(function (Crop) {
    Crop["ALFALFA"] = "ALFALFA";
    Crop["ALFALFA_HAYLAGE"] = "ALFALFA_HAYLAGE";
    Crop["BARLEY"] = "BARLEY";
    Crop["BARLEY_SPRING"] = "BARLEY_SPRING";
    Crop["BLUEGRASS"] = "BLUEGRASS";
    Crop["CABBAGE"] = "CABBAGE";
    Crop["CANOLA"] = "CANOLA";
    Crop["CARROTS"] = "CARROTS";
    Crop["CHICKPEAS"] = "CHICKPEAS";
    Crop["CLOVER"] = "CLOVER";
    Crop["CORN"] = "CORN";
    Crop["CORN_CERTIFIED_ORGANIC"] = "CORN_CERTIFIED_ORGANIC";
    Crop["CORN_CONVENTIONAL"] = "CORN_CONVENTIONAL";
    Crop["CORN_NON_GM"] = "CORN_NON_GM";
    Crop["CORN_TWOYELLOW_ORGANIC"] = "CORN_TWOYELLOW_ORGANIC";
    Crop["CORN_RED"] = "CORN_RED";
    Crop["CORN_RESOURCE_EFFICIENT"] = "CORN_RESOURCE_EFFICIENT";
    Crop["CORN_SILLAGE"] = "CORN_SILLAGE";
    Crop["CORN_TWOYELLOW"] = "CORN_TWOYELLOW";
    Crop["CORN_TWOYELLOW_NONGM"] = "CORN_TWOYELLOW_NONGM";
    Crop["CORN_WAXY"] = "CORN_WAXY";
    Crop["CORN_WHITE"] = "CORN_WHITE";
    Crop["CORN_WHITE_ORGANIC"] = "CORN_WHITE_ORGANIC";
    Crop["COTTON"] = "COTTON";
    Crop["COTTON_CONVENTIONAL"] = "COTTON_CONVENTIONAL";
    Crop["COTTON_IRRIGATED"] = "COTTON_IRRIGATED";
    Crop["COTTON_NON_GM"] = "COTTON_NON_GM";
    Crop["COTTON_NON_IRRIGATED"] = "COTTON_NON_IRRIGATED";
    Crop["COTTON_ORGANIC"] = "COTTON_ORGANIC";
    Crop["CUCUMBERS"] = "CUCUMBERS";
    Crop["DOUBLE_CROP_SOYBEAN"] = "DOUBLE_CROP_SOYBEAN";
    Crop["GRASS"] = "GRASS";
    Crop["GRASS_HAY"] = "GRASS_HAY";
    Crop["GREENS"] = "GREENS";
    Crop["GREEN_BEANS"] = "GREEN_BEANS";
    Crop["LIMA_BEANS"] = "LIMA_BEANS";
    Crop["MELONS"] = "MELONS";
    Crop["MILLET"] = "MILLET";
    Crop["NATIVE_GRASS"] = "NATIVE_GRASS";
    Crop["OATS"] = "OATS";
    Crop["OATS_ORGANIC"] = "OATS_ORGANIC";
    Crop["OATS_SPRING"] = "OATS_SPRING";
    Crop["ORCHARDGRASS"] = "ORCHARDGRASS";
    Crop["OTHER"] = "OTHER";
    Crop["PEAS"] = "PEAS";
    Crop["FIELDPEAS"] = "FIELDPEAS";
    Crop["FIELDPEAS_ORGANIC"] = "FIELDPEAS_ORGANIC";
    Crop["PERENNIAL_RYEGRASS"] = "PERENNIAL_RYEGRASS";
    Crop["POPCORN"] = "POPCORN";
    Crop["POTATOES"] = "POTATOES";
    Crop["PUMPKINS"] = "PUMPKINS";
    Crop["REED_CANARYGRASS"] = "REED_CANARYGRASS";
    Crop["RICE"] = "RICE";
    Crop["RICE_CONVENTIONAL"] = "RICE_CONVENTIONAL";
    Crop["RICE_MEDIUM_GRAIN"] = "RICE_MEDIUM_GRAIN";
    Crop["RICE_ORGANIC"] = "RICE_ORGANIC";
    Crop["RICE_ORGANIC_LONGGRAIN"] = "RICE_ORGANIC_LONGGRAIN";
    Crop["RICE_ORGANIC_MEDGRAIN"] = "RICE_ORGANIC_MEDGRAIN";
    Crop["RICE_ORGANIC_SHORTGRAIN"] = "RICE_ORGANIC_SHORTGRAIN";
    Crop["RICE_ORGANIC_UNSPECIFIED"] = "RICE_ORGANIC_UNSPECIFIED";
    Crop["RICE_LONGGRAIN"] = "RICE_LONGGRAIN";
    Crop["RICE_MEDGRAIN"] = "RICE_MEDGRAIN";
    Crop["RICE_SHORTGRAIN"] = "RICE_SHORTGRAIN";
    Crop["RICE_UNSPECIFIED"] = "RICE_UNSPECIFIED";
    Crop["RYE"] = "RYE";
    Crop["RYE_ORGANIC"] = "RYE_ORGANIC";
    Crop["SINGLE_CROP"] = "SINGLE_CROP";
    Crop["SMOOTH_BROMEGRASS"] = "SMOOTH_BROMEGRASS";
    Crop["SNAP_BEANS"] = "SNAP_BEANS";
    Crop["SORGHUM"] = "SORGHUM";
    Crop["SORGHUM_MILO"] = "SORGHUM_MILO";
    Crop["SORGHUM_ORGANIC"] = "SORGHUM_ORGANIC";
    Crop["SORGHUM_SILAGE"] = "SORGHUM_SILAGE";
    Crop["SOYBEANS"] = "SOYBEANS";
    Crop["SOYBEANS_CONVENTIONAL"] = "SOYBEANS_CONVENTIONAL";
    Crop["SOYBEANS_ORGANIC"] = "SOYBEANS_ORGANIC";
    Crop["SOYBEANS_RESOURCE_EFFICIENT"] = "SOYBEANS_RESOURCE_EFFICIENT";
    Crop["SOYBEANS_NONGM"] = "SOYBEANS_NONGM";
    Crop["SUNDANGRASS"] = "SUNDANGRASS";
    Crop["SUNFLOWER"] = "SUNFLOWER";
    Crop["SUNFLOWER_ORGANIC"] = "SUNFLOWER_ORGANIC";
    Crop["SWEET_CORN"] = "SWEET_CORN";
    Crop["TALL_FESCUE"] = "TALL_FESCUE";
    Crop["TOBACCO"] = "TOBACCO";
    Crop["TOBACCO_BURLEY"] = "TOBACCO_BURLEY";
    Crop["TOMATOES"] = "TOMATOES";
    Crop["TRITICALE"] = "TRITICALE";
    Crop["TRITICALE_ORGANIC"] = "TRITICALE_ORGANIC";
    Crop["WHEAT"] = "WHEAT";
    Crop["WHEAT_DURUM"] = "WHEAT_DURUM";
    Crop["WHEAT_DURUM_ORGANIC"] = "WHEAT_DURUM_ORGANIC";
    Crop["WHEAT_HARDWHITE_TRAITED_GM"] = "WHEAT_HARDWHITE_TRAITED_GM";
    Crop["WHEAT_HARDWHITE_UNTRAITED_NONGM"] = "WHEAT_HARDWHITE_UNTRAITED_NONGM";
    Crop["WHEAT_MILLING_QUALITY_HARD_RED_WINTER"] = "WHEAT_MILLING_QUALITY_HARD_RED_WINTER";
    Crop["WHEAT_SOFTWHITE_ORGANIC"] = "WHEAT_SOFTWHITE_ORGANIC";
    Crop["WHEAT_SOFTWHITE_TRAITED_GM"] = "WHEAT_SOFTWHITE_TRAITED_GM";
    Crop["WHEAT_SOFTWHITE_UNTRAITED_NONGM"] = "WHEAT_SOFTWHITE_UNTRAITED_NONGM";
    Crop["WHEAT_SPRING_HARDRED"] = "WHEAT_SPRING_HARDRED";
    Crop["WHEAT_SPRING_HARDRED_ORGANIC"] = "WHEAT_SPRING_HARDRED_ORGANIC";
    Crop["WHEAT_SPRING_HARD_WHITE"] = "WHEAT_SPRING_HARD_WHITE";
    Crop["WHEAT_SPRING_ORGANIC_HARD_RED"] = "WHEAT_SPRING_ORGANIC_HARD_RED";
    Crop["WHEAT_SPRING_SOFT_WHITE"] = "WHEAT_SPRING_SOFT_WHITE";
    Crop["WHEAT_WINTER_HARDRED"] = "WHEAT_WINTER_HARDRED";
    Crop["WHEAT_WINTER_HARDRED_ORGANIC"] = "WHEAT_WINTER_HARDRED_ORGANIC";
    Crop["WHEAT_WINTER_HARDWHITE"] = "WHEAT_WINTER_HARDWHITE";
    Crop["WHEAT_WINTER_HARDWHITE_ORGANIC"] = "WHEAT_WINTER_HARDWHITE_ORGANIC";
    Crop["WHEAT_WINTER_ORGANIC_HARD_WHITE"] = "WHEAT_WINTER_ORGANIC_HARD_WHITE";
    Crop["WHEAT_WINTER_ORGANIC_SOFT_RED"] = "WHEAT_WINTER_ORGANIC_SOFT_RED";
    Crop["WHEAT_WINTER_SOFTRED"] = "WHEAT_WINTER_SOFTRED";
    Crop["WHEAT_WINTER_SOFTRED_ORGANIC"] = "WHEAT_WINTER_SOFTRED_ORGANIC";
    Crop["WHEAT_WINTER_SOFTWHITE"] = "WHEAT_WINTER_SOFTWHITE";
    Crop["WHEAT_WINTER_SOFTWHITE_ORGANIC"] = "WHEAT_WINTER_SOFTWHITE_ORGANIC";
    Crop["WHEAT_WINTER_SOFT_WHITE"] = "WHEAT_WINTER_SOFT_WHITE";
    Crop["WINTER_WHEAT"] = "WINTER_WHEAT";
})(Crop = exports.Crop || (exports.Crop = {}));
var CropQuantityUnit;
(function (CropQuantityUnit) {
    CropQuantityUnit["BUSHELS"] = "BUSHELS";
    CropQuantityUnit["CWT"] = "CWT";
    CropQuantityUnit["POUNDS"] = "POUNDS";
    CropQuantityUnit["TONS"] = "TONS";
    CropQuantityUnit["SHORT_TON"] = "SHORT_TON";
    CropQuantityUnit["METRIC_TONS"] = "METRIC_TONS";
    CropQuantityUnit["METRIC_TON"] = "METRIC_TON";
    CropQuantityUnit["BALES"] = "BALES";
    CropQuantityUnit["PALLETS"] = "PALLETS";
    CropQuantityUnit["BAGS"] = "BAGS";
})(CropQuantityUnit = exports.CropQuantityUnit || (exports.CropQuantityUnit = {}));
var CropWeightUnit;
(function (CropWeightUnit) {
    CropWeightUnit["POUNDS"] = "POUNDS";
})(CropWeightUnit = exports.CropWeightUnit || (exports.CropWeightUnit = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["USD"] = "USD";
    CurrencyCode["BRL"] = "BRL";
})(CurrencyCode = exports.CurrencyCode || (exports.CurrencyCode = {}));
var DecisionBackgroundCheckStepStatus;
(function (DecisionBackgroundCheckStepStatus) {
    DecisionBackgroundCheckStepStatus["FAILED"] = "FAILED";
    DecisionBackgroundCheckStepStatus["PASSED"] = "PASSED";
})(DecisionBackgroundCheckStepStatus = exports.DecisionBackgroundCheckStepStatus || (exports.DecisionBackgroundCheckStepStatus = {}));
var DevicePlatform;
(function (DevicePlatform) {
    DevicePlatform["ANDROID"] = "ANDROID";
    DevicePlatform["IOS"] = "IOS";
})(DevicePlatform = exports.DevicePlatform || (exports.DevicePlatform = {}));
var Distance;
(function (Distance) {
    Distance["MILES"] = "MILES";
})(Distance = exports.Distance || (exports.Distance = {}));
var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["MILES"] = "MILES";
    DistanceUnit["KILOMETERS"] = "KILOMETERS";
})(DistanceUnit = exports.DistanceUnit || (exports.DistanceUnit = {}));
var ElevatorMetricsType;
(function (ElevatorMetricsType) {
    ElevatorMetricsType["NEAREST"] = "NEAREST";
    ElevatorMetricsType["MAX_PROFIT"] = "MAX_PROFIT";
})(ElevatorMetricsType = exports.ElevatorMetricsType || (exports.ElevatorMetricsType = {}));
var EmailStatus;
(function (EmailStatus) {
    EmailStatus["QUEUED"] = "QUEUED";
    EmailStatus["SENT"] = "SENT";
})(EmailStatus = exports.EmailStatus || (exports.EmailStatus = {}));
var ERROR_CODE;
(function (ERROR_CODE) {
    ERROR_CODE["INPUT_NOT_PROVIDED"] = "INPUT_NOT_PROVIDED";
    ERROR_CODE["NOT_SUPORTED"] = "NOT_SUPORTED";
    ERROR_CODE["SCALAR_VALIDATION_FAILURE"] = "SCALAR_VALIDATION_FAILURE";
    ERROR_CODE["TRANSPORT_NOT_ALLOWED"] = "TRANSPORT_NOT_ALLOWED";
    ERROR_CODE["TRANSPORT_TRIP_NOT_FOUND"] = "TRANSPORT_TRIP_NOT_FOUND";
    ERROR_CODE["TRANSPORT_FILE_TYPE_NOT_SUPPORTED"] = "TRANSPORT_FILE_TYPE_NOT_SUPPORTED";
    ERROR_CODE["TRANSPORT_FILE_MISSING"] = "TRANSPORT_FILE_MISSING";
})(ERROR_CODE = exports.ERROR_CODE || (exports.ERROR_CODE = {}));
var FieldMonitoringStatus;
(function (FieldMonitoringStatus) {
    FieldMonitoringStatus["IN_PROGRESS"] = "IN_PROGRESS";
    FieldMonitoringStatus["NOT_STARTED"] = "NOT_STARTED";
    FieldMonitoringStatus["COMPLETED"] = "COMPLETED";
    FieldMonitoringStatus["ON_HOLD"] = "ON_HOLD";
})(FieldMonitoringStatus = exports.FieldMonitoringStatus || (exports.FieldMonitoringStatus = {}));
var FinancingApplicationStatus;
(function (FinancingApplicationStatus) {
    FinancingApplicationStatus["STARTED"] = "STARTED";
    FinancingApplicationStatus["UNDER_REVIEW"] = "UNDER_REVIEW";
    FinancingApplicationStatus["APPROVED"] = "APPROVED";
    FinancingApplicationStatus["DENIED"] = "DENIED";
})(FinancingApplicationStatus = exports.FinancingApplicationStatus || (exports.FinancingApplicationStatus = {}));
var FinancingCivilStatus;
(function (FinancingCivilStatus) {
    FinancingCivilStatus["SINGLE"] = "SINGLE";
    FinancingCivilStatus["MARRIED"] = "MARRIED";
    FinancingCivilStatus["DIVORCED"] = "DIVORCED";
})(FinancingCivilStatus = exports.FinancingCivilStatus || (exports.FinancingCivilStatus = {}));
var FinancingFixGrainPriceTiming;
(function (FinancingFixGrainPriceTiming) {
    FinancingFixGrainPriceTiming["NOW"] = "NOW";
    FinancingFixGrainPriceTiming["LATER"] = "LATER";
})(FinancingFixGrainPriceTiming = exports.FinancingFixGrainPriceTiming || (exports.FinancingFixGrainPriceTiming = {}));
var FinancingProcessBrEventType;
(function (FinancingProcessBrEventType) {
    FinancingProcessBrEventType["PHASE_1_APPROVED"] = "PHASE_1_APPROVED";
    FinancingProcessBrEventType["PHASE_1_DENIED"] = "PHASE_1_DENIED";
    FinancingProcessBrEventType["PHASE_1_COPIED"] = "PHASE_1_COPIED";
    FinancingProcessBrEventType["PHASE_1_AWAITING_MANAGER_APPROVAL"] = "PHASE_1_AWAITING_MANAGER_APPROVAL";
    FinancingProcessBrEventType["PHASE_2_STARTED"] = "PHASE_2_STARTED";
    FinancingProcessBrEventType["PHASE_2_APPROVED"] = "PHASE_2_APPROVED";
    FinancingProcessBrEventType["PHASE_2_DENIED"] = "PHASE_2_DENIED";
    FinancingProcessBrEventType["PHASE_2_ON_HOLD"] = "PHASE_2_ON_HOLD";
    FinancingProcessBrEventType["PHASE_2_WAITING_COMMITTEE_DECISION"] = "PHASE_2_WAITING_COMMITTEE_DECISION";
    FinancingProcessBrEventType["PHASE_2_PENDING_ACTIVATION"] = "PHASE_2_PENDING_ACTIVATION";
    FinancingProcessBrEventType["PHASE_2_AWAITING_COMMERCIAL_DEAL"] = "PHASE_2_AWAITING_COMMERCIAL_DEAL";
    FinancingProcessBrEventType["COLLATERAL_ANALYSIS_SENT"] = "COLLATERAL_ANALYSIS_SENT";
    FinancingProcessBrEventType["COLLATERAL_ANALYSIS_APPROVED"] = "COLLATERAL_ANALYSIS_APPROVED";
    FinancingProcessBrEventType["COLLATERAL_ANALYSIS_DENIED"] = "COLLATERAL_ANALYSIS_DENIED";
    FinancingProcessBrEventType["COLLATERAL_ANALYSIS_SENT_TO_CREDIT_MANAGER"] = "COLLATERAL_ANALYSIS_SENT_TO_CREDIT_MANAGER";
    FinancingProcessBrEventType["COLLATERAL_ANALYSIS_RESTARTED"] = "COLLATERAL_ANALYSIS_RESTARTED";
    FinancingProcessBrEventType["COLLATERAL_ANALYSIS_ON_HOLD"] = "COLLATERAL_ANALYSIS_ON_HOLD";
    FinancingProcessBrEventType["COLLATERAL_ANALYSIS_RESUMED"] = "COLLATERAL_ANALYSIS_RESUMED";
    FinancingProcessBrEventType["COLLATERAL_CRP_SENT"] = "COLLATERAL_CRP_SENT";
    FinancingProcessBrEventType["COLLATERAL_CRP_SENT_BACK_FOR_REVISION"] = "COLLATERAL_CRP_SENT_BACK_FOR_REVISION";
    FinancingProcessBrEventType["COLLATERAL_CRP_APPROVED"] = "COLLATERAL_CRP_APPROVED";
    FinancingProcessBrEventType["CREDIT_MARKED_AS_COMPLETE"] = "CREDIT_MARKED_AS_COMPLETE";
    FinancingProcessBrEventType["CREDIT_ANALYSIS_APPROVED"] = "CREDIT_ANALYSIS_APPROVED";
    FinancingProcessBrEventType["CREDIT_ANALYSIS_DENIED"] = "CREDIT_ANALYSIS_DENIED";
    FinancingProcessBrEventType["CREDIT_ANALYSIS_SENT_TO_CREDIT_MANAGER"] = "CREDIT_ANALYSIS_SENT_TO_CREDIT_MANAGER";
    FinancingProcessBrEventType["CREDIT_ANALYSIS_RESTARTED"] = "CREDIT_ANALYSIS_RESTARTED";
    FinancingProcessBrEventType["CREDIT_ANALYSIS_ON_HOLD"] = "CREDIT_ANALYSIS_ON_HOLD";
    FinancingProcessBrEventType["CREDIT_ANALYSIS_RESUMED"] = "CREDIT_ANALYSIS_RESUMED";
    FinancingProcessBrEventType["CREDIT_APPROVAL_CREDIT_ANALYST_APPROVED"] = "CREDIT_APPROVAL_CREDIT_ANALYST_APPROVED";
    FinancingProcessBrEventType["CREDIT_APPROVAL_DENIED"] = "CREDIT_APPROVAL_DENIED";
    FinancingProcessBrEventType["CREDIT_APPROVAL_SENT_TO_CREDIT_MANAGER"] = "CREDIT_APPROVAL_SENT_TO_CREDIT_MANAGER";
    FinancingProcessBrEventType["CREDIT_APPROVAL_CREDIT_MANAGER_APPROVED"] = "CREDIT_APPROVAL_CREDIT_MANAGER_APPROVED";
    FinancingProcessBrEventType["CREDIT_APPROVAL_RESET"] = "CREDIT_APPROVAL_RESET";
    FinancingProcessBrEventType["FIELD_MONITORING_COMPLETED"] = "FIELD_MONITORING_COMPLETED";
    FinancingProcessBrEventType["FIELD_MONITORING_ON_HOLD"] = "FIELD_MONITORING_ON_HOLD";
    FinancingProcessBrEventType["FIELD_MONITORING_RESUMED"] = "FIELD_MONITORING_RESUMED";
    FinancingProcessBrEventType["FIELD_MONITORING_RESTARTED"] = "FIELD_MONITORING_RESTARTED";
    FinancingProcessBrEventType["OTHER"] = "OTHER";
    FinancingProcessBrEventType["DOCUMENT_REQUEST_CREATED"] = "DOCUMENT_REQUEST_CREATED";
    FinancingProcessBrEventType["DOCUMENT_REQUEST_APPROVED"] = "DOCUMENT_REQUEST_APPROVED";
    FinancingProcessBrEventType["DOCUMENT_REQUEST_DENIED"] = "DOCUMENT_REQUEST_DENIED";
    FinancingProcessBrEventType["DOCUMENT_REQUEST_DELETED"] = "DOCUMENT_REQUEST_DELETED";
    FinancingProcessBrEventType["DOCUMENT_REQUEST_REVISION_REQUIRED"] = "DOCUMENT_REQUEST_REVISION_REQUIRED";
    FinancingProcessBrEventType["DOCUMENT_REQUEST_SUBMISSION_RECEIVED"] = "DOCUMENT_REQUEST_SUBMISSION_RECEIVED";
    FinancingProcessBrEventType["TIMELINE_COMMENT"] = "TIMELINE_COMMENT";
    FinancingProcessBrEventType["PHASE_3_STARTED"] = "PHASE_3_STARTED";
    FinancingProcessBrEventType["PHASE_3_DRAFT_SENT_TO_COMMERCIAL"] = "PHASE_3_DRAFT_SENT_TO_COMMERCIAL";
    FinancingProcessBrEventType["PHASE_3_REVIEWING_SIGNED_DOCUMENTS"] = "PHASE_3_REVIEWING_SIGNED_DOCUMENTS";
    FinancingProcessBrEventType["PHASE_3_SIGNED_DOCUMENTS_APPROVED"] = "PHASE_3_SIGNED_DOCUMENTS_APPROVED";
    FinancingProcessBrEventType["PHASE_3_SIGNED_DOCUMENTS_DENIED"] = "PHASE_3_SIGNED_DOCUMENTS_DENIED";
    FinancingProcessBrEventType["PHASE_3_SIGNED_DOCUMENTS_SENT_TO_CREDIT_TEAM"] = "PHASE_3_SIGNED_DOCUMENTS_SENT_TO_CREDIT_TEAM";
    FinancingProcessBrEventType["PHASE_3_APPROVED_CONDITIONALS"] = "PHASE_3_APPROVED_CONDITIONALS";
    FinancingProcessBrEventType["PHASE_3_PHYSICAL_DOCUMENTS_RECEIVED"] = "PHASE_3_PHYSICAL_DOCUMENTS_RECEIVED";
    FinancingProcessBrEventType["PHASE_3_SIGNED_DOCUMENTS_RETURNED_TO_COLLATERAL"] = "PHASE_3_SIGNED_DOCUMENTS_RETURNED_TO_COLLATERAL";
    FinancingProcessBrEventType["PHASE_3_SIGNED_DOCUMENTS_SENT_TO_CREDIT_MANAGER"] = "PHASE_3_SIGNED_DOCUMENTS_SENT_TO_CREDIT_MANAGER";
    FinancingProcessBrEventType["PHASE_3_CREATING_AMENDMENT"] = "PHASE_3_CREATING_AMENDMENT";
    FinancingProcessBrEventType["PHASE_3_DIGITAL_SIGNATURE_REQUESTED"] = "PHASE_3_DIGITAL_SIGNATURE_REQUESTED";
    FinancingProcessBrEventType["PHASE_3_PHYSICAL_SIGNATURE_REQUESTED"] = "PHASE_3_PHYSICAL_SIGNATURE_REQUESTED";
    FinancingProcessBrEventType["PHASE_3_AMENDMENT_SIGNED"] = "PHASE_3_AMENDMENT_SIGNED";
    FinancingProcessBrEventType["PHASE_3_DENIED"] = "PHASE_3_DENIED";
    FinancingProcessBrEventType["PHASE_3_ON_HOLD"] = "PHASE_3_ON_HOLD";
    FinancingProcessBrEventType["PHASE_4_AWAITING_ASSIGNMENT"] = "PHASE_4_AWAITING_ASSIGNMENT";
    FinancingProcessBrEventType["PHASE_4_ASSIGNED_TO_FUND"] = "PHASE_4_ASSIGNED_TO_FUND";
    FinancingProcessBrEventType["PHASE_4_RECEIVED_BY_FUND"] = "PHASE_4_RECEIVED_BY_FUND";
    FinancingProcessBrEventType["PHASE_4_AWAITING_MANAGER_APPROVAL"] = "PHASE_4_AWAITING_MANAGER_APPROVAL";
    FinancingProcessBrEventType["PHASE_4_MANAGER_DENIED"] = "PHASE_4_MANAGER_DENIED";
    FinancingProcessBrEventType["PHASE_4_SUBMITTED_MINUTA"] = "PHASE_4_SUBMITTED_MINUTA";
    FinancingProcessBrEventType["PHASE_4_ADDED_TO_GROUP"] = "PHASE_4_ADDED_TO_GROUP";
    FinancingProcessBrEventType["PHASE_4_REMOVED_FROM_GROUP"] = "PHASE_4_REMOVED_FROM_GROUP";
    FinancingProcessBrEventType["PHASE_4_ON_HOLD"] = "PHASE_4_ON_HOLD";
    FinancingProcessBrEventType["FINANCING_PROCESS_COMPLETED"] = "FINANCING_PROCESS_COMPLETED";
    FinancingProcessBrEventType["FINANCING_PROCESS_COMPLETED_MANUALLY"] = "FINANCING_PROCESS_COMPLETED_MANUALLY";
    FinancingProcessBrEventType["MARKED_AS_PRIORITY"] = "MARKED_AS_PRIORITY";
    FinancingProcessBrEventType["UNMARKED_AS_PRIORITY"] = "UNMARKED_AS_PRIORITY";
    FinancingProcessBrEventType["CONTACT_RISK_CLASSIFICATION_ADDED"] = "CONTACT_RISK_CLASSIFICATION_ADDED";
    FinancingProcessBrEventType["IMPORTED_EXCEPTIONS_AND_CONDITIONALS"] = "IMPORTED_EXCEPTIONS_AND_CONDITIONALS";
    FinancingProcessBrEventType["ADD_EXCEPTION"] = "ADD_EXCEPTION";
    FinancingProcessBrEventType["ADD_CONDITIONAL"] = "ADD_CONDITIONAL";
})(FinancingProcessBrEventType = exports.FinancingProcessBrEventType || (exports.FinancingProcessBrEventType = {}));
var FuturesMonthCode;
(function (FuturesMonthCode) {
    FuturesMonthCode["F"] = "F";
    FuturesMonthCode["G"] = "G";
    FuturesMonthCode["H"] = "H";
    FuturesMonthCode["J"] = "J";
    FuturesMonthCode["K"] = "K";
    FuturesMonthCode["M"] = "M";
    FuturesMonthCode["N"] = "N";
    FuturesMonthCode["Q"] = "Q";
    FuturesMonthCode["U"] = "U";
    FuturesMonthCode["V"] = "V";
    FuturesMonthCode["X"] = "X";
    FuturesMonthCode["Z"] = "Z";
})(FuturesMonthCode = exports.FuturesMonthCode || (exports.FuturesMonthCode = {}));
var Grain;
(function (Grain) {
    Grain["CORN"] = "CORN";
    Grain["COTTON"] = "COTTON";
    Grain["SOYBEAN"] = "SOYBEAN";
})(Grain = exports.Grain || (exports.Grain = {}));
var HardRedWinterWheatVariety;
(function (HardRedWinterWheatVariety) {
    HardRedWinterWheatVariety["ANY"] = "ANY";
    HardRedWinterWheatVariety["AVERY"] = "AVERY";
    HardRedWinterWheatVariety["BOB_DOLE"] = "BOB_DOLE";
    HardRedWinterWheatVariety["BYRD"] = "BYRD";
    HardRedWinterWheatVariety["DOUBLESTOP_CL_PLUS"] = "DOUBLESTOP_CL_PLUS";
    HardRedWinterWheatVariety["GALLAGHER"] = "GALLAGHER";
    HardRedWinterWheatVariety["LCS_MINT"] = "LCS_MINT";
    HardRedWinterWheatVariety["OTHER"] = "OTHER";
    HardRedWinterWheatVariety["SY_MONUMENT"] = "SY_MONUMENT";
    HardRedWinterWheatVariety["TAM_112"] = "TAM_112";
    HardRedWinterWheatVariety["TAM_114"] = "TAM_114";
})(HardRedWinterWheatVariety = exports.HardRedWinterWheatVariety || (exports.HardRedWinterWheatVariety = {}));
var HtmlSnapshotType;
(function (HtmlSnapshotType) {
    HtmlSnapshotType["CPA_DECISION_SHEET"] = "CPA_DECISION_SHEET";
})(HtmlSnapshotType = exports.HtmlSnapshotType || (exports.HtmlSnapshotType = {}));
var Irrigation;
(function (Irrigation) {
    Irrigation["CENTER_PIVOT"] = "CENTER_PIVOT";
    Irrigation["DRIP_TAPE"] = "DRIP_TAPE";
    Irrigation["FLOOD"] = "FLOOD";
    Irrigation["FURROW"] = "FURROW";
    Irrigation["LATERAL_MOVE"] = "LATERAL_MOVE";
    Irrigation["MANUAL"] = "MANUAL";
    Irrigation["NON_IRRIGATED"] = "NON_IRRIGATED";
    Irrigation["SURFACE"] = "SURFACE";
})(Irrigation = exports.Irrigation || (exports.Irrigation = {}));
var JudicialActionFlag;
(function (JudicialActionFlag) {
    JudicialActionFlag["RED"] = "RED";
    JudicialActionFlag["GREEN"] = "GREEN";
    JudicialActionFlag["YELLOW"] = "YELLOW";
})(JudicialActionFlag = exports.JudicialActionFlag || (exports.JudicialActionFlag = {}));
var LegalEntityType;
(function (LegalEntityType) {
    LegalEntityType["LLC"] = "LLC";
    LegalEntityType["INDIVIDUAL"] = "INDIVIDUAL";
    LegalEntityType["PARTNERSHIP"] = "PARTNERSHIP";
    LegalEntityType["TRUST"] = "TRUST";
    LegalEntityType["CORPORATION"] = "CORPORATION";
    LegalEntityType["OTHER"] = "OTHER";
    LegalEntityType["SOLE_PROPRIETORSHIP"] = "SOLE_PROPRIETORSHIP";
})(LegalEntityType = exports.LegalEntityType || (exports.LegalEntityType = {}));
var MarketplaceAdminRoles;
(function (MarketplaceAdminRoles) {
    MarketplaceAdminRoles["grain_marketing_advisor"] = "grain_marketing_advisor";
    MarketplaceAdminRoles["grain_marketplace_admin"] = "grain_marketplace_admin";
    MarketplaceAdminRoles["grain_marketplace_bam"] = "grain_marketplace_bam";
    MarketplaceAdminRoles["grain_marketplace_buyer"] = "grain_marketplace_buyer";
    MarketplaceAdminRoles["grain_marketplace_gam"] = "grain_marketplace_gam";
    MarketplaceAdminRoles["grain_marketplace_hedging"] = "grain_marketplace_hedging";
    MarketplaceAdminRoles["grower_customer_service"] = "grower_customer_service";
})(MarketplaceAdminRoles = exports.MarketplaceAdminRoles || (exports.MarketplaceAdminRoles = {}));
var MarketplaceGrowerRoles;
(function (MarketplaceGrowerRoles) {
    MarketplaceGrowerRoles["grain_marketplace_seller"] = "grain_marketplace_seller";
    MarketplaceGrowerRoles["grain_marketplace_readonly"] = "grain_marketplace_readonly";
    MarketplaceGrowerRoles["grain_marketplace_seller_admin"] = "grain_marketplace_seller_admin";
    MarketplaceGrowerRoles["grain_marketplace_seller_inventory"] = "grain_marketplace_seller_inventory";
    MarketplaceGrowerRoles["grain_marketplace_seller_bids"] = "grain_marketplace_seller_bids";
    MarketplaceGrowerRoles["grain_marketplace_seller_offers"] = "grain_marketplace_seller_offers";
})(MarketplaceGrowerRoles = exports.MarketplaceGrowerRoles || (exports.MarketplaceGrowerRoles = {}));
var MatriculaBiome;
(function (MatriculaBiome) {
    MatriculaBiome["CERRADO"] = "CERRADO";
    MatriculaBiome["AMAZON"] = "AMAZON";
    MatriculaBiome["CAATINGA"] = "CAATINGA";
    MatriculaBiome["ATLANTIC_FOREST"] = "ATLANTIC_FOREST";
    MatriculaBiome["PANTANAL"] = "PANTANAL";
    MatriculaBiome["PAMPA"] = "PAMPA";
})(MatriculaBiome = exports.MatriculaBiome || (exports.MatriculaBiome = {}));
var MatriculaTerritoryStatusQuery;
(function (MatriculaTerritoryStatusQuery) {
    MatriculaTerritoryStatusQuery["HAS_TERRITORY"] = "HAS_TERRITORY";
    MatriculaTerritoryStatusQuery["DOES_NOT_HAVE_TERRITORY"] = "DOES_NOT_HAVE_TERRITORY";
    MatriculaTerritoryStatusQuery["QUERY_FAILED"] = "QUERY_FAILED";
})(MatriculaTerritoryStatusQuery = exports.MatriculaTerritoryStatusQuery || (exports.MatriculaTerritoryStatusQuery = {}));
var Month;
(function (Month) {
    Month["JANUARY"] = "JANUARY";
    Month["FEBRUARY"] = "FEBRUARY";
    Month["MARCH"] = "MARCH";
    Month["APRIL"] = "APRIL";
    Month["MAY"] = "MAY";
    Month["JUNE"] = "JUNE";
    Month["JULY"] = "JULY";
    Month["AUGUST"] = "AUGUST";
    Month["SEPTEMBER"] = "SEPTEMBER";
    Month["OCTOBER"] = "OCTOBER";
    Month["NOVEMBER"] = "NOVEMBER";
    Month["DECEMBER"] = "DECEMBER";
})(Month = exports.Month || (exports.Month = {}));
var MonthCode;
(function (MonthCode) {
    MonthCode["F"] = "F";
    MonthCode["G"] = "G";
    MonthCode["H"] = "H";
    MonthCode["J"] = "J";
    MonthCode["K"] = "K";
    MonthCode["M"] = "M";
    MonthCode["N"] = "N";
    MonthCode["Q"] = "Q";
    MonthCode["U"] = "U";
    MonthCode["V"] = "V";
    MonthCode["X"] = "X";
    MonthCode["Z"] = "Z";
})(MonthCode = exports.MonthCode || (exports.MonthCode = {}));
var MyAccountsOrderByInput;
(function (MyAccountsOrderByInput) {
    MyAccountsOrderByInput["name_ASC"] = "name_ASC";
    MyAccountsOrderByInput["name_DESC"] = "name_DESC";
    MyAccountsOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    MyAccountsOrderByInput["createdAt_DESC"] = "createdAt_DESC";
})(MyAccountsOrderByInput = exports.MyAccountsOrderByInput || (exports.MyAccountsOrderByInput = {}));
var OpportunityRegional;
(function (OpportunityRegional) {
    OpportunityRegional["INDUSTRIAL_SALE_AND_ALLIANCE"] = "INDUSTRIAL_SALE_AND_ALLIANCE";
    OpportunityRegional["VD_SOUTH_REGION"] = "VD_SOUTH_REGION";
    OpportunityRegional["VD_MATO_GROSSO_REGION"] = "VD_MATO_GROSSO_REGION";
    OpportunityRegional["VD_NORTH_REGION"] = "VD_NORTH_REGION";
    OpportunityRegional["VD_NORTH_EAST_REGION"] = "VD_NORTH_EAST_REGION";
    OpportunityRegional["VD_CENTER_REGION"] = "VD_CENTER_REGION";
    OpportunityRegional["VI_MS_PARANA_REGION"] = "VI_MS_PARANA_REGION";
    OpportunityRegional["VI_MINAS_GERAL_REGION"] = "VI_MINAS_GERAL_REGION";
    OpportunityRegional["VI_MATO_GROSSO_REGION"] = "VI_MATO_GROSSO_REGION";
    OpportunityRegional["VI_SAO_PAULO_REGION"] = "VI_SAO_PAULO_REGION";
    OpportunityRegional["VI_GOIAS_REGION"] = "VI_GOIAS_REGION";
    OpportunityRegional["NOT_SET"] = "NOT_SET";
})(OpportunityRegional = exports.OpportunityRegional || (exports.OpportunityRegional = {}));
var OpportunitySaleType;
(function (OpportunitySaleType) {
    OpportunitySaleType["DIRECT"] = "DIRECT";
    OpportunitySaleType["INDIRECT"] = "INDIRECT";
    OpportunitySaleType["NOT_SET"] = "NOT_SET";
})(OpportunitySaleType = exports.OpportunitySaleType || (exports.OpportunitySaleType = {}));
var OpportunityType;
(function (OpportunityType) {
    OpportunityType["CASH"] = "CASH";
    OpportunityType["BARTER"] = "BARTER";
    OpportunityType["BARTER_GUARANTEE"] = "BARTER_GUARANTEE";
    OpportunityType["BARTER_LIMIT"] = "BARTER_LIMIT";
    OpportunityType["BONUS"] = "BONUS";
    OpportunityType["DEMAND_GENERATION"] = "DEMAND_GENERATION";
    OpportunityType["NOT_SET"] = "NOT_SET";
    OpportunityType["SAMPLE"] = "SAMPLE";
    OpportunityType["SUPPLIER"] = "SUPPLIER";
})(OpportunityType = exports.OpportunityType || (exports.OpportunityType = {}));
var OrderCancelationStatus;
(function (OrderCancelationStatus) {
    OrderCancelationStatus["CANCELABLE"] = "CANCELABLE";
    OrderCancelationStatus["NOT_CANCELABLE"] = "NOT_CANCELABLE";
})(OrderCancelationStatus = exports.OrderCancelationStatus || (exports.OrderCancelationStatus = {}));
var OrderReasonNotCancelable;
(function (OrderReasonNotCancelable) {
    OrderReasonNotCancelable["CARRIER_ORDERS_ATTACHED"] = "CARRIER_ORDERS_ATTACHED";
    OrderReasonNotCancelable["HAS_DELIVERED_LOADS"] = "HAS_DELIVERED_LOADS";
})(OrderReasonNotCancelable = exports.OrderReasonNotCancelable || (exports.OrderReasonNotCancelable = {}));
var OrderUnassignableStatus;
(function (OrderUnassignableStatus) {
    OrderUnassignableStatus["UNASSIGNABLE"] = "UNASSIGNABLE";
    OrderUnassignableStatus["BLOCKED_HAS_UNCANCELABLE_TRIPS"] = "BLOCKED_HAS_UNCANCELABLE_TRIPS";
    OrderUnassignableStatus["BLOCKED_STILL_CREATING_TRIPS"] = "BLOCKED_STILL_CREATING_TRIPS";
})(OrderUnassignableStatus = exports.OrderUnassignableStatus || (exports.OrderUnassignableStatus = {}));
var OrganicHardRedWinterWheatVariety;
(function (OrganicHardRedWinterWheatVariety) {
    OrganicHardRedWinterWheatVariety["ANY"] = "ANY";
    OrganicHardRedWinterWheatVariety["AVERY"] = "AVERY";
    OrganicHardRedWinterWheatVariety["BOB_DOLE"] = "BOB_DOLE";
    OrganicHardRedWinterWheatVariety["BYRD"] = "BYRD";
    OrganicHardRedWinterWheatVariety["DOUBLESTOP_CL_PLUS"] = "DOUBLESTOP_CL_PLUS";
    OrganicHardRedWinterWheatVariety["GALLAGHER"] = "GALLAGHER";
    OrganicHardRedWinterWheatVariety["LCS_MINT"] = "LCS_MINT";
    OrganicHardRedWinterWheatVariety["OTHER"] = "OTHER";
    OrganicHardRedWinterWheatVariety["SY_MONUMENT"] = "SY_MONUMENT";
    OrganicHardRedWinterWheatVariety["TAM_112"] = "TAM_112";
    OrganicHardRedWinterWheatVariety["TAM_114"] = "TAM_114";
})(OrganicHardRedWinterWheatVariety = exports.OrganicHardRedWinterWheatVariety || (exports.OrganicHardRedWinterWheatVariety = {}));
var PendencyStatus;
(function (PendencyStatus) {
    PendencyStatus["PENDING"] = "PENDING";
    PendencyStatus["APPROVED"] = "APPROVED";
    PendencyStatus["DENIED"] = "DENIED";
})(PendencyStatus = exports.PendencyStatus || (exports.PendencyStatus = {}));
var PermissionOrderByInput;
(function (PermissionOrderByInput) {
    PermissionOrderByInput["code_ASC"] = "code_ASC";
    PermissionOrderByInput["code_DESC"] = "code_DESC";
    PermissionOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    PermissionOrderByInput["createdAt_DESC"] = "createdAt_DESC";
    PermissionOrderByInput["updatedAt_ASC"] = "updatedAt_ASC";
    PermissionOrderByInput["updatedAt_DESC"] = "updatedAt_DESC";
})(PermissionOrderByInput = exports.PermissionOrderByInput || (exports.PermissionOrderByInput = {}));
var PledgeLevel;
(function (PledgeLevel) {
    PledgeLevel["FIRST"] = "FIRST";
    PledgeLevel["SECOND"] = "SECOND";
    PledgeLevel["THIRD"] = "THIRD";
    PledgeLevel["NEGATIVE"] = "NEGATIVE";
})(PledgeLevel = exports.PledgeLevel || (exports.PledgeLevel = {}));
var RiceVariety;
(function (RiceVariety) {
    RiceVariety["ANY"] = "ANY";
    RiceVariety["CHENIERE"] = "CHENIERE";
    RiceVariety["CL111"] = "CL111";
    RiceVariety["CL153"] = "CL153";
    RiceVariety["DIAMOND"] = "DIAMOND";
    RiceVariety["OTHER"] = "OTHER";
    RiceVariety["PRESIDIO"] = "PRESIDIO";
})(RiceVariety = exports.RiceVariety || (exports.RiceVariety = {}));
var RiskClassificationLevel;
(function (RiskClassificationLevel) {
    RiskClassificationLevel["VERY_HIGH"] = "VERY_HIGH";
    RiskClassificationLevel["HIGH"] = "HIGH";
    RiskClassificationLevel["MEDIUM"] = "MEDIUM";
    RiskClassificationLevel["LOW"] = "LOW";
    RiskClassificationLevel["VERY_LOW"] = "VERY_LOW";
    RiskClassificationLevel["NOT_CLASSIFIED"] = "NOT_CLASSIFIED";
})(RiskClassificationLevel = exports.RiskClassificationLevel || (exports.RiskClassificationLevel = {}));
var RiskClassificationStatus;
(function (RiskClassificationStatus) {
    RiskClassificationStatus["CLEARED"] = "CLEARED";
    RiskClassificationStatus["EXPIRED"] = "EXPIRED";
    RiskClassificationStatus["FAILED"] = "FAILED";
})(RiskClassificationStatus = exports.RiskClassificationStatus || (exports.RiskClassificationStatus = {}));
var RoleOrderByInput;
(function (RoleOrderByInput) {
    RoleOrderByInput["name_ASC"] = "name_ASC";
    RoleOrderByInput["name_DESC"] = "name_DESC";
    RoleOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    RoleOrderByInput["createdAt_DESC"] = "createdAt_DESC";
    RoleOrderByInput["updatedAt_ASC"] = "updatedAt_ASC";
    RoleOrderByInput["updatedAt_DESC"] = "updatedAt_DESC";
})(RoleOrderByInput = exports.RoleOrderByInput || (exports.RoleOrderByInput = {}));
var SalesRegion;
(function (SalesRegion) {
    SalesRegion["COASTAL_BEND"] = "COASTAL_BEND";
    SalesRegion["HIGH_PLAINS"] = "HIGH_PLAINS";
    SalesRegion["MIDSOUTH"] = "MIDSOUTH";
    SalesRegion["MIDWEST"] = "MIDWEST";
    SalesRegion["NORTH_CENTRAL"] = "NORTH_CENTRAL";
    SalesRegion["NORTHEAST"] = "NORTHEAST";
    SalesRegion["RICE"] = "RICE";
    SalesRegion["SOUTHEAST"] = "SOUTHEAST";
    SalesRegion["SOUTHERN_WHEAT_BELT"] = "SOUTHERN_WHEAT_BELT";
    SalesRegion["SOUTHWEST_COTTON_REGION"] = "SOUTHWEST_COTTON_REGION";
    SalesRegion["SOUTHWEST_COTTON_REGION_COASTAL_BEND"] = "SOUTHWEST_COTTON_REGION_COASTAL_BEND";
    SalesRegion["TEXAS"] = "TEXAS";
})(SalesRegion = exports.SalesRegion || (exports.SalesRegion = {}));
var Season;
(function (Season) {
    Season["FALL"] = "FALL";
    Season["SPRING"] = "SPRING";
    Season["SUMMER"] = "SUMMER";
    Season["WINTER"] = "WINTER";
})(Season = exports.Season || (exports.Season = {}));
var SerasaApiStatus;
(function (SerasaApiStatus) {
    SerasaApiStatus["CLEARED"] = "CLEARED";
    SerasaApiStatus["FAILED"] = "FAILED";
    SerasaApiStatus["UNRESOLVED"] = "UNRESOLVED";
})(SerasaApiStatus = exports.SerasaApiStatus || (exports.SerasaApiStatus = {}));
var SerasaOccurrence;
(function (SerasaOccurrence) {
    SerasaOccurrence["PEFIN"] = "PEFIN";
    SerasaOccurrence["REFIN"] = "REFIN";
    SerasaOccurrence["NOTARY"] = "NOTARY";
    SerasaOccurrence["CHECK"] = "CHECK";
    SerasaOccurrence["COLLECTION_RECORDS"] = "COLLECTION_RECORDS";
    SerasaOccurrence["JUDGEMENT_FILINGS"] = "JUDGEMENT_FILINGS";
    SerasaOccurrence["BANKRUPTS"] = "BANKRUPTS";
    SerasaOccurrence["NEGATIVE_SUMMARY"] = "NEGATIVE_SUMMARY";
})(SerasaOccurrence = exports.SerasaOccurrence || (exports.SerasaOccurrence = {}));
var ShipperCarrierOrderHistoryOrderByInput;
(function (ShipperCarrierOrderHistoryOrderByInput) {
    ShipperCarrierOrderHistoryOrderByInput["timesUsed_ASC"] = "timesUsed_ASC";
    ShipperCarrierOrderHistoryOrderByInput["timesUsed_DESC"] = "timesUsed_DESC";
    ShipperCarrierOrderHistoryOrderByInput["lastRate_ASC"] = "lastRate_ASC";
    ShipperCarrierOrderHistoryOrderByInput["lastRate_DESC"] = "lastRate_DESC";
    ShipperCarrierOrderHistoryOrderByInput["lastUsed_ASC"] = "lastUsed_ASC";
    ShipperCarrierOrderHistoryOrderByInput["lastUsed_DESC"] = "lastUsed_DESC";
})(ShipperCarrierOrderHistoryOrderByInput = exports.ShipperCarrierOrderHistoryOrderByInput || (exports.ShipperCarrierOrderHistoryOrderByInput = {}));
var ShipperLoadGeneralStatus;
(function (ShipperLoadGeneralStatus) {
    ShipperLoadGeneralStatus["NOT_CLAIMED"] = "NOT_CLAIMED";
    ShipperLoadGeneralStatus["NOT_STARTED"] = "NOT_STARTED";
    ShipperLoadGeneralStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ShipperLoadGeneralStatus["DELIVERED"] = "DELIVERED";
    ShipperLoadGeneralStatus["ISSUES"] = "ISSUES";
})(ShipperLoadGeneralStatus = exports.ShipperLoadGeneralStatus || (exports.ShipperLoadGeneralStatus = {}));
var ShipperShippingOrderLoadOrderByInput;
(function (ShipperShippingOrderLoadOrderByInput) {
    ShipperShippingOrderLoadOrderByInput["scheduledDeliveryAt_ASC"] = "scheduledDeliveryAt_ASC";
    ShipperShippingOrderLoadOrderByInput["scheduledDeliveryAt_DESC"] = "scheduledDeliveryAt_DESC";
    ShipperShippingOrderLoadOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    ShipperShippingOrderLoadOrderByInput["createdAt_DESC"] = "createdAt_DESC";
})(ShipperShippingOrderLoadOrderByInput = exports.ShipperShippingOrderLoadOrderByInput || (exports.ShipperShippingOrderLoadOrderByInput = {}));
var ShipperStatus;
(function (ShipperStatus) {
    ShipperStatus["ACCEPTED"] = "ACCEPTED";
    ShipperStatus["PENDING"] = "PENDING";
    ShipperStatus["BANNED"] = "BANNED";
    ShipperStatus["INACTIVE"] = "INACTIVE";
})(ShipperStatus = exports.ShipperStatus || (exports.ShipperStatus = {}));
var ShippingOrderGeneralStatus;
(function (ShippingOrderGeneralStatus) {
    ShippingOrderGeneralStatus["PENDING"] = "PENDING";
    ShippingOrderGeneralStatus["ACTIVE"] = "ACTIVE";
    ShippingOrderGeneralStatus["PAST"] = "PAST";
})(ShippingOrderGeneralStatus = exports.ShippingOrderGeneralStatus || (exports.ShippingOrderGeneralStatus = {}));
var SoftRedWinterWheatVariety;
(function (SoftRedWinterWheatVariety) {
    SoftRedWinterWheatVariety["ANY"] = "ANY";
    SoftRedWinterWheatVariety["OTHER"] = "OTHER";
    SoftRedWinterWheatVariety["_134B"] = "_134B";
    SoftRedWinterWheatVariety["_124C"] = "_124C";
    SoftRedWinterWheatVariety["_113B"] = "_113B";
    SoftRedWinterWheatVariety["_114B"] = "_114B";
    SoftRedWinterWheatVariety["_294A"] = "_294A";
    SoftRedWinterWheatVariety["_284A"] = "_284A";
    SoftRedWinterWheatVariety["_273A"] = "_273A";
    SoftRedWinterWheatVariety["_215C"] = "_215C";
})(SoftRedWinterWheatVariety = exports.SoftRedWinterWheatVariety || (exports.SoftRedWinterWheatVariety = {}));
var SoilGrade;
(function (SoilGrade) {
    SoilGrade["GOOD"] = "GOOD";
    SoilGrade["MEDIUM"] = "MEDIUM";
    SoilGrade["SANDY"] = "SANDY";
})(SoilGrade = exports.SoilGrade || (exports.SoilGrade = {}));
var SoilTillage;
(function (SoilTillage) {
    SoilTillage["CONVENTIONAL"] = "CONVENTIONAL";
    SoilTillage["DEEP_TILL"] = "DEEP_TILL";
    SoilTillage["MINIMUM_TILL"] = "MINIMUM_TILL";
    SoilTillage["MULCH_TILL"] = "MULCH_TILL";
    SoilTillage["NO_TILL"] = "NO_TILL";
    SoilTillage["RIDGE_TILL"] = "RIDGE_TILL";
    SoilTillage["SEEDBED_PREPARATION"] = "SEEDBED_PREPARATION";
    SoilTillage["STRIP_TILL"] = "STRIP_TILL";
})(SoilTillage = exports.SoilTillage || (exports.SoilTillage = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var SoyVariety;
(function (SoyVariety) {
    SoyVariety["ANY"] = "ANY";
    SoyVariety["OTHER"] = "OTHER";
    SoyVariety["RR2X"] = "RR2X";
    SoyVariety["TS3600LL"] = "TS3600LL";
    SoyVariety["TS3759R2"] = "TS3759R2";
    SoyVariety["TS3800LL"] = "TS3800LL";
    SoyVariety["TS4000LL"] = "TS4000LL";
    SoyVariety["TS3769R2X"] = "TS3769R2X";
    SoyVariety["TS3969R2X"] = "TS3969R2X";
    SoyVariety["TS4070"] = "TS4070";
    SoyVariety["TS4249R2X"] = "TS4249R2X";
    SoyVariety["TS4270"] = "TS4270";
    SoyVariety["TS4569R2X"] = "TS4569R2X";
    SoyVariety["TS4579R2XS"] = "TS4579R2XS";
    SoyVariety["TS4710GTS"] = "TS4710GTS";
    SoyVariety["TS4889R2X"] = "TS4889R2X";
    SoyVariety["TS4899R2XS"] = "TS4899R2XS";
    SoyVariety["TS5119R2XS"] = "TS5119R2XS";
    SoyVariety["TS5329R2X"] = "TS5329R2X";
    SoyVariety["TS5669R2X"] = "TS5669R2X";
    SoyVariety["TS6289R2X"] = "TS6289R2X";
})(SoyVariety = exports.SoyVariety || (exports.SoyVariety = {}));
var Stage;
(function (Stage) {
    Stage["ACTIVE_CONVERSATION"] = "ACTIVE_CONVERSATION";
    Stage["CLOSED_LOST"] = "CLOSED_LOST";
    Stage["CLOSED_WON"] = "CLOSED_WON";
    Stage["CONTRACT_PENDING"] = "CONTRACT_PENDING";
    Stage["CONTRACT_SUBMITTED"] = "CONTRACT_SUBMITTED";
    Stage["GROWER_MEETING"] = "GROWER_MEETING";
    Stage["PRESENTATION"] = "PRESENTATION";
    Stage["PRESENTATION_ESTIMATE"] = "PRESENTATION_ESTIMATE";
    Stage["PRESENTED_TO"] = "PRESENTED_TO";
    Stage["PROPOSAL_PRICE_QUOTE"] = "PROPOSAL_PRICE_QUOTE";
    Stage["QUALIFICATION"] = "QUALIFICATION";
    Stage["VERBAL_COMMITMENT"] = "VERBAL_COMMITMENT";
})(Stage = exports.Stage || (exports.Stage = {}));
var TenderingParty;
(function (TenderingParty) {
    TenderingParty["INDIGO"] = "INDIGO";
    TenderingParty["SELF"] = "SELF";
})(TenderingParty = exports.TenderingParty || (exports.TenderingParty = {}));
var TextMessageDirection;
(function (TextMessageDirection) {
    TextMessageDirection["INCOMING"] = "INCOMING";
    TextMessageDirection["OUTGOING"] = "OUTGOING";
})(TextMessageDirection = exports.TextMessageDirection || (exports.TextMessageDirection = {}));
var TextMessageType;
(function (TextMessageType) {
    TextMessageType["HELP"] = "HELP";
    TextMessageType["OPT_IN"] = "OPT_IN";
    TextMessageType["OPT_OUT"] = "OPT_OUT";
    TextMessageType["OTHER"] = "OTHER";
    TextMessageType["WELCOME"] = "WELCOME";
    TextMessageType["BID_SUMMARY"] = "BID_SUMMARY";
})(TextMessageType = exports.TextMessageType || (exports.TextMessageType = {}));
var TinVerificationStatus;
(function (TinVerificationStatus) {
    TinVerificationStatus["NOT_SUBMITTED"] = "NOT_SUBMITTED";
    TinVerificationStatus["PENDING"] = "PENDING";
    TinVerificationStatus["INVALID"] = "INVALID";
    TinVerificationStatus["VERIFIED"] = "VERIFIED";
})(TinVerificationStatus = exports.TinVerificationStatus || (exports.TinVerificationStatus = {}));
var TransportCarrierFreightRequestOfferType;
(function (TransportCarrierFreightRequestOfferType) {
    TransportCarrierFreightRequestOfferType["DIRECT"] = "DIRECT";
    TransportCarrierFreightRequestOfferType["OPEN"] = "OPEN";
})(TransportCarrierFreightRequestOfferType = exports.TransportCarrierFreightRequestOfferType || (exports.TransportCarrierFreightRequestOfferType = {}));
var TransportCarrierLoadStatus;
(function (TransportCarrierLoadStatus) {
    TransportCarrierLoadStatus["NOT_STARTED"] = "NOT_STARTED";
    TransportCarrierLoadStatus["PICKED_UP"] = "PICKED_UP";
    TransportCarrierLoadStatus["DROPPED_OFF"] = "DROPPED_OFF";
})(TransportCarrierLoadStatus = exports.TransportCarrierLoadStatus || (exports.TransportCarrierLoadStatus = {}));
var TransportCounterOfferStatus;
(function (TransportCounterOfferStatus) {
    TransportCounterOfferStatus["ACCEPTED"] = "ACCEPTED";
    TransportCounterOfferStatus["ACTIVE"] = "ACTIVE";
    TransportCounterOfferStatus["CANCELED"] = "CANCELED";
    TransportCounterOfferStatus["COUNTERED"] = "COUNTERED";
    TransportCounterOfferStatus["EXPIRED"] = "EXPIRED";
    TransportCounterOfferStatus["REJECTED"] = "REJECTED";
})(TransportCounterOfferStatus = exports.TransportCounterOfferStatus || (exports.TransportCounterOfferStatus = {}));
var TransportDirectOfferStatus;
(function (TransportDirectOfferStatus) {
    TransportDirectOfferStatus["ACCEPTED"] = "ACCEPTED";
    TransportDirectOfferStatus["ACTIVE"] = "ACTIVE";
    TransportDirectOfferStatus["CANCELED"] = "CANCELED";
    TransportDirectOfferStatus["COUNTERED"] = "COUNTERED";
    TransportDirectOfferStatus["EXPIRED"] = "EXPIRED";
    TransportDirectOfferStatus["REJECTED"] = "REJECTED";
})(TransportDirectOfferStatus = exports.TransportDirectOfferStatus || (exports.TransportDirectOfferStatus = {}));
var TransportFreightRequestOrderByInput;
(function (TransportFreightRequestOrderByInput) {
    TransportFreightRequestOrderByInput["deliveryWindowEnd_ASC"] = "deliveryWindowEnd_ASC";
    TransportFreightRequestOrderByInput["deliveryWindowEnd_DESC"] = "deliveryWindowEnd_DESC";
    TransportFreightRequestOrderByInput["deliveryWindowStart_ASC"] = "deliveryWindowStart_ASC";
    TransportFreightRequestOrderByInput["deliveryWindowStart_DESC"] = "deliveryWindowStart_DESC";
    TransportFreightRequestOrderByInput["destinationCity_ASC"] = "destinationCity_ASC";
    TransportFreightRequestOrderByInput["destinationCity_DESC"] = "destinationCity_DESC";
    TransportFreightRequestOrderByInput["destinationState_ASC"] = "destinationState_ASC";
    TransportFreightRequestOrderByInput["destinationState_DESC"] = "destinationState_DESC";
    TransportFreightRequestOrderByInput["originCity_ASC"] = "originCity_ASC";
    TransportFreightRequestOrderByInput["originCity_DESC"] = "originCity_DESC";
    TransportFreightRequestOrderByInput["originState_ASC"] = "originState_ASC";
    TransportFreightRequestOrderByInput["originState_DESC"] = "originState_DESC";
    TransportFreightRequestOrderByInput["expiresAt_ASC"] = "expiresAt_ASC";
    TransportFreightRequestOrderByInput["expiresAt_DESC"] = "expiresAt_DESC";
    TransportFreightRequestOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    TransportFreightRequestOrderByInput["createdAt_DESC"] = "createdAt_DESC";
    TransportFreightRequestOrderByInput["offerType_ASC"] = "offerType_ASC";
    TransportFreightRequestOrderByInput["offerType_DESC"] = "offerType_DESC";
    TransportFreightRequestOrderByInput["productCode_ASC"] = "productCode_ASC";
    TransportFreightRequestOrderByInput["productCode_DESC"] = "productCode_DESC";
})(TransportFreightRequestOrderByInput = exports.TransportFreightRequestOrderByInput || (exports.TransportFreightRequestOrderByInput = {}));
var TransportOpenOfferStatus;
(function (TransportOpenOfferStatus) {
    TransportOpenOfferStatus["ACTIVE"] = "ACTIVE";
    TransportOpenOfferStatus["CANCELED"] = "CANCELED";
    TransportOpenOfferStatus["EXPIRED"] = "EXPIRED";
    TransportOpenOfferStatus["FULFILLED"] = "FULFILLED";
    TransportOpenOfferStatus["COUNTERED"] = "COUNTERED";
    TransportOpenOfferStatus["REJECTED"] = "REJECTED";
})(TransportOpenOfferStatus = exports.TransportOpenOfferStatus || (exports.TransportOpenOfferStatus = {}));
var TransportOrderSortBy;
(function (TransportOrderSortBy) {
    TransportOrderSortBy["UID"] = "UID";
    TransportOrderSortBy["ORIGIN"] = "ORIGIN";
    TransportOrderSortBy["DESTINATION"] = "DESTINATION";
    TransportOrderSortBy["PRODUCT_NAME"] = "PRODUCT_NAME";
    TransportOrderSortBy["ORDER_STATUS"] = "ORDER_STATUS";
    TransportOrderSortBy["DELIVERY_WINDOW_START_DATE"] = "DELIVERY_WINDOW_START_DATE";
})(TransportOrderSortBy = exports.TransportOrderSortBy || (exports.TransportOrderSortBy = {}));
var TransportOrderStatus;
(function (TransportOrderStatus) {
    TransportOrderStatus["PENDING"] = "PENDING";
    TransportOrderStatus["NOT_STARTED"] = "NOT_STARTED";
    TransportOrderStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TransportOrderStatus["COMPLETE"] = "COMPLETE";
    TransportOrderStatus["CANCELED"] = "CANCELED";
})(TransportOrderStatus = exports.TransportOrderStatus || (exports.TransportOrderStatus = {}));
var TransportRateType;
(function (TransportRateType) {
    TransportRateType["PER_QUANTITY_UNIT"] = "PER_QUANTITY_UNIT";
    TransportRateType["PER_LOAD"] = "PER_LOAD";
})(TransportRateType = exports.TransportRateType || (exports.TransportRateType = {}));
var TransportUserType;
(function (TransportUserType) {
    TransportUserType["ADMIN"] = "ADMIN";
    TransportUserType["CARRIER"] = "CARRIER";
    TransportUserType["DISPATCHER"] = "DISPATCHER";
    TransportUserType["DRIVER"] = "DRIVER";
    TransportUserType["INDIGO_USER"] = "INDIGO_USER";
    TransportUserType["SYSTEM_USER"] = "SYSTEM_USER";
})(TransportUserType = exports.TransportUserType || (exports.TransportUserType = {}));
var TripUncancelableReason;
(function (TripUncancelableReason) {
    TripUncancelableReason["DELIVERY_STATUS"] = "DELIVERY_STATUS";
    TripUncancelableReason["PAYMENT_STATUS"] = "PAYMENT_STATUS";
})(TripUncancelableReason = exports.TripUncancelableReason || (exports.TripUncancelableReason = {}));
var TruckingAgreementType;
(function (TruckingAgreementType) {
    TruckingAgreementType["TRUCKING_AGREEMENT"] = "TRUCKING_AGREEMENT";
    TruckingAgreementType["TRANSPORTATION_MANUAL"] = "TRANSPORTATION_MANUAL";
    TruckingAgreementType["TERMS_OF_USE"] = "TERMS_OF_USE";
    TruckingAgreementType["WORKERS_COMPENSATION"] = "WORKERS_COMPENSATION";
    TruckingAgreementType["CERTIFICATE_OF_LIABILITY_INSURANCE"] = "CERTIFICATE_OF_LIABILITY_INSURANCE";
    TruckingAgreementType["SHIPPER_AGREEMENT"] = "SHIPPER_AGREEMENT";
    TruckingAgreementType["SHIPPER_TERMS_OF_USE"] = "SHIPPER_TERMS_OF_USE";
})(TruckingAgreementType = exports.TruckingAgreementType || (exports.TruckingAgreementType = {}));
var TruckingCarrierOrderByInput;
(function (TruckingCarrierOrderByInput) {
    TruckingCarrierOrderByInput["id_ASC"] = "id_ASC";
    TruckingCarrierOrderByInput["id_DESC"] = "id_DESC";
    TruckingCarrierOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    TruckingCarrierOrderByInput["createdAt_DESC"] = "createdAt_DESC";
})(TruckingCarrierOrderByInput = exports.TruckingCarrierOrderByInput || (exports.TruckingCarrierOrderByInput = {}));
var TruckingCarrierPaymentType;
(function (TruckingCarrierPaymentType) {
    TruckingCarrierPaymentType["MAILED_CHECK"] = "MAILED_CHECK";
})(TruckingCarrierPaymentType = exports.TruckingCarrierPaymentType || (exports.TruckingCarrierPaymentType = {}));
var TruckingCarrierStatus;
(function (TruckingCarrierStatus) {
    TruckingCarrierStatus["ACCEPTED"] = "ACCEPTED";
    TruckingCarrierStatus["PENDING"] = "PENDING";
    TruckingCarrierStatus["BANNED"] = "BANNED";
    TruckingCarrierStatus["INACTIVE"] = "INACTIVE";
})(TruckingCarrierStatus = exports.TruckingCarrierStatus || (exports.TruckingCarrierStatus = {}));
var TruckingDocumentStatus;
(function (TruckingDocumentStatus) {
    TruckingDocumentStatus["PENDING"] = "PENDING";
    TruckingDocumentStatus["ACCEPTED"] = "ACCEPTED";
    TruckingDocumentStatus["REJECTED"] = "REJECTED";
})(TruckingDocumentStatus = exports.TruckingDocumentStatus || (exports.TruckingDocumentStatus = {}));
var TruckingDocumentType;
(function (TruckingDocumentType) {
    TruckingDocumentType["ACCESSORIAL_CHARGE"] = "ACCESSORIAL_CHARGE";
    TruckingDocumentType["AUTO_LIABILITY"] = "AUTO_LIABILITY";
    TruckingDocumentType["COMMERCIAL_GENERAL_LIABILITY"] = "COMMERCIAL_GENERAL_LIABILITY";
    TruckingDocumentType["CARGO_LIABILITY"] = "CARGO_LIABILITY";
    TruckingDocumentType["WORKERS_COMP"] = "WORKERS_COMP";
    TruckingDocumentType["SCALE_TICKET"] = "SCALE_TICKET";
    TruckingDocumentType["BILL_OF_LADING"] = "BILL_OF_LADING";
    TruckingDocumentType["W9"] = "W9";
    TruckingDocumentType["WASHOUT"] = "WASHOUT";
})(TruckingDocumentType = exports.TruckingDocumentType || (exports.TruckingDocumentType = {}));
var TruckingOrderByInput;
(function (TruckingOrderByInput) {
    TruckingOrderByInput["id_ASC"] = "id_ASC";
    TruckingOrderByInput["id_DESC"] = "id_DESC";
    TruckingOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    TruckingOrderByInput["createdAt_DESC"] = "createdAt_DESC";
    TruckingOrderByInput["distanceToOrigin_ASC"] = "distanceToOrigin_ASC";
    TruckingOrderByInput["distanceToOrigin_DESC"] = "distanceToOrigin_DESC";
    TruckingOrderByInput["deliveryDate_ASC"] = "deliveryDate_ASC";
    TruckingOrderByInput["deliveryDate_DESC"] = "deliveryDate_DESC";
})(TruckingOrderByInput = exports.TruckingOrderByInput || (exports.TruckingOrderByInput = {}));
var TruckingOrderState;
(function (TruckingOrderState) {
    TruckingOrderState["CLAIMED"] = "CLAIMED";
    TruckingOrderState["COMPLETE"] = "COMPLETE";
    TruckingOrderState["OPEN"] = "OPEN";
    TruckingOrderState["IN_PROGRESS"] = "IN_PROGRESS";
})(TruckingOrderState = exports.TruckingOrderState || (exports.TruckingOrderState = {}));
var TruckingPricingModelFilter;
(function (TruckingPricingModelFilter) {
    TruckingPricingModelFilter["INDIGO"] = "INDIGO";
    TruckingPricingModelFilter["CUSTOM"] = "CUSTOM";
})(TruckingPricingModelFilter = exports.TruckingPricingModelFilter || (exports.TruckingPricingModelFilter = {}));
var TruckingPricingOverrideType;
(function (TruckingPricingOverrideType) {
    TruckingPricingOverrideType["ORDER"] = "ORDER";
    TruckingPricingOverrideType["TRIP"] = "TRIP";
    TruckingPricingOverrideType["QUOTE"] = "QUOTE";
})(TruckingPricingOverrideType = exports.TruckingPricingOverrideType || (exports.TruckingPricingOverrideType = {}));
var TruckingPricingRate;
(function (TruckingPricingRate) {
    TruckingPricingRate["PER_UNIT"] = "PER_UNIT";
    TruckingPricingRate["PER_DISTANCE"] = "PER_DISTANCE";
    TruckingPricingRate["PER_UNIT_PER_DISTANCE"] = "PER_UNIT_PER_DISTANCE";
    TruckingPricingRate["FLAT_FEE"] = "FLAT_FEE";
})(TruckingPricingRate = exports.TruckingPricingRate || (exports.TruckingPricingRate = {}));
var TruckingPricingSource;
(function (TruckingPricingSource) {
    TruckingPricingSource["INDIGO_DEFAULT"] = "INDIGO_DEFAULT";
    TruckingPricingSource["INDIGO_GUARANTEE"] = "INDIGO_GUARANTEE";
    TruckingPricingSource["INDIGO_OVERRIDE_ORDER"] = "INDIGO_OVERRIDE_ORDER";
    TruckingPricingSource["INDIGO_OVERRIDE_TRIP"] = "INDIGO_OVERRIDE_TRIP";
    TruckingPricingSource["SHIPPER_CUSTOM"] = "SHIPPER_CUSTOM";
    TruckingPricingSource["CARRIER_QUOTE"] = "CARRIER_QUOTE";
    TruckingPricingSource["RATE_CARD"] = "RATE_CARD";
    TruckingPricingSource["PIECEWISE"] = "PIECEWISE";
})(TruckingPricingSource = exports.TruckingPricingSource || (exports.TruckingPricingSource = {}));
var TruckingPricingType;
(function (TruckingPricingType) {
    TruckingPricingType["ORIGIN_CITY_DESTINATION_CITY"] = "ORIGIN_CITY_DESTINATION_CITY";
    TruckingPricingType["DESTINATION_CITY_RANGE"] = "DESTINATION_CITY_RANGE";
    TruckingPricingType["DESTINATION_STATE"] = "DESTINATION_STATE";
})(TruckingPricingType = exports.TruckingPricingType || (exports.TruckingPricingType = {}));
var TruckingQuoteOrderByInput;
(function (TruckingQuoteOrderByInput) {
    TruckingQuoteOrderByInput["CREATED_AT"] = "CREATED_AT";
})(TruckingQuoteOrderByInput = exports.TruckingQuoteOrderByInput || (exports.TruckingQuoteOrderByInput = {}));
var TruckingQuoteStatus;
(function (TruckingQuoteStatus) {
    TruckingQuoteStatus["PENDING"] = "PENDING";
    TruckingQuoteStatus["ACCEPTED"] = "ACCEPTED";
    TruckingQuoteStatus["REJECTED"] = "REJECTED";
    TruckingQuoteStatus["REVOKED"] = "REVOKED";
})(TruckingQuoteStatus = exports.TruckingQuoteStatus || (exports.TruckingQuoteStatus = {}));
var TruckingStorageType;
(function (TruckingStorageType) {
    TruckingStorageType["BAG"] = "BAG";
    TruckingStorageType["BIN"] = "BIN";
})(TruckingStorageType = exports.TruckingStorageType || (exports.TruckingStorageType = {}));
var TruckingTripAccessorialChargeType;
(function (TruckingTripAccessorialChargeType) {
    TruckingTripAccessorialChargeType["DETENTION_AT_DESTINATION"] = "DETENTION_AT_DESTINATION";
    TruckingTripAccessorialChargeType["DETENTION_AT_ORIGIN"] = "DETENTION_AT_ORIGIN";
    TruckingTripAccessorialChargeType["EXCESS_MILEAGE"] = "EXCESS_MILEAGE";
    TruckingTripAccessorialChargeType["LAYOVER"] = "LAYOVER";
    TruckingTripAccessorialChargeType["THIRD_PARTY_QUALITY_TESTING"] = "THIRD_PARTY_QUALITY_TESTING";
    TruckingTripAccessorialChargeType["WASHOUT"] = "WASHOUT";
    TruckingTripAccessorialChargeType["OTHER"] = "OTHER";
})(TruckingTripAccessorialChargeType = exports.TruckingTripAccessorialChargeType || (exports.TruckingTripAccessorialChargeType = {}));
var TruckingTripDeliveryStatus;
(function (TruckingTripDeliveryStatus) {
    TruckingTripDeliveryStatus["UNCLAIMED"] = "UNCLAIMED";
    TruckingTripDeliveryStatus["CLAIMED"] = "CLAIMED";
    TruckingTripDeliveryStatus["DELIVERED"] = "DELIVERED";
    TruckingTripDeliveryStatus["CANCELLED"] = "CANCELLED";
})(TruckingTripDeliveryStatus = exports.TruckingTripDeliveryStatus || (exports.TruckingTripDeliveryStatus = {}));
var TruckingTripDeliveryType;
(function (TruckingTripDeliveryType) {
    TruckingTripDeliveryType["INDIGO"] = "INDIGO";
    TruckingTripDeliveryType["THIRD_PARTY_SHIPPER"] = "THIRD_PARTY_SHIPPER";
    TruckingTripDeliveryType["OUT_OF_NETWORK"] = "OUT_OF_NETWORK";
})(TruckingTripDeliveryType = exports.TruckingTripDeliveryType || (exports.TruckingTripDeliveryType = {}));
var TruckingTripIssueOrderByInput;
(function (TruckingTripIssueOrderByInput) {
    TruckingTripIssueOrderByInput["CREATED_AT"] = "CREATED_AT";
})(TruckingTripIssueOrderByInput = exports.TruckingTripIssueOrderByInput || (exports.TruckingTripIssueOrderByInput = {}));
var TruckingTripIssueStatus;
(function (TruckingTripIssueStatus) {
    TruckingTripIssueStatus["PENDING"] = "PENDING";
    TruckingTripIssueStatus["RESOLVED"] = "RESOLVED";
})(TruckingTripIssueStatus = exports.TruckingTripIssueStatus || (exports.TruckingTripIssueStatus = {}));
var TruckingTripPaymentStatus;
(function (TruckingTripPaymentStatus) {
    TruckingTripPaymentStatus["NOT_SUBMITTED"] = "NOT_SUBMITTED";
    TruckingTripPaymentStatus["SUBMITTED_FOR_APPROVAL"] = "SUBMITTED_FOR_APPROVAL";
    TruckingTripPaymentStatus["APPROVED_FOR_PAYMENT"] = "APPROVED_FOR_PAYMENT";
    TruckingTripPaymentStatus["PENDING_EXPORT_TO_SETTLEMENTS"] = "PENDING_EXPORT_TO_SETTLEMENTS";
    TruckingTripPaymentStatus["EXPORTED_TO_SETTLEMENTS"] = "EXPORTED_TO_SETTLEMENTS";
})(TruckingTripPaymentStatus = exports.TruckingTripPaymentStatus || (exports.TruckingTripPaymentStatus = {}));
var TruckingTripProgressStatus;
(function (TruckingTripProgressStatus) {
    TruckingTripProgressStatus["PENDING"] = "PENDING";
    TruckingTripProgressStatus["STARTED_TRIP_AT"] = "STARTED_TRIP_AT";
    TruckingTripProgressStatus["ARRIVED_AT_ORIGIN_AT"] = "ARRIVED_AT_ORIGIN_AT";
    TruckingTripProgressStatus["PICKED_UP_AT"] = "PICKED_UP_AT";
    TruckingTripProgressStatus["ARRIVED_AT_DESTINATION_AT"] = "ARRIVED_AT_DESTINATION_AT";
    TruckingTripProgressStatus["UNLOADED_AT"] = "UNLOADED_AT";
    TruckingTripProgressStatus["DRIVER_DONE_AT"] = "DRIVER_DONE_AT";
})(TruckingTripProgressStatus = exports.TruckingTripProgressStatus || (exports.TruckingTripProgressStatus = {}));
var TruckingTripState;
(function (TruckingTripState) {
    TruckingTripState["COMPLETE"] = "COMPLETE";
    TruckingTripState["UPCOMING"] = "UPCOMING";
    TruckingTripState["EXPIRED"] = "EXPIRED";
})(TruckingTripState = exports.TruckingTripState || (exports.TruckingTripState = {}));
var TruckingTripStatusFilter;
(function (TruckingTripStatusFilter) {
    TruckingTripStatusFilter["NOT_STARTED"] = "NOT_STARTED";
    TruckingTripStatusFilter["ARRIVED_AT_ORIGIN"] = "ARRIVED_AT_ORIGIN";
    TruckingTripStatusFilter["DEPARTED_ORIGIN"] = "DEPARTED_ORIGIN";
    TruckingTripStatusFilter["ARRIVED_AT_DESTINATION"] = "ARRIVED_AT_DESTINATION";
    TruckingTripStatusFilter["DROPPED_OF_LOAD"] = "DROPPED_OF_LOAD";
    TruckingTripStatusFilter["ISSUE_AT_ORIGIN"] = "ISSUE_AT_ORIGIN";
    TruckingTripStatusFilter["ISSUE_ON_ROAD"] = "ISSUE_ON_ROAD";
    TruckingTripStatusFilter["ISSUE_AT_DESTINATION"] = "ISSUE_AT_DESTINATION";
})(TruckingTripStatusFilter = exports.TruckingTripStatusFilter || (exports.TruckingTripStatusFilter = {}));
var UndefinedCropVariety;
(function (UndefinedCropVariety) {
    UndefinedCropVariety["ANY"] = "ANY";
    UndefinedCropVariety["OTHER"] = "OTHER";
})(UndefinedCropVariety = exports.UndefinedCropVariety || (exports.UndefinedCropVariety = {}));
var UnitOfMeasure;
(function (UnitOfMeasure) {
    UnitOfMeasure["BALES"] = "BALES";
    UnitOfMeasure["BUSHELS"] = "BUSHELS";
    UnitOfMeasure["CWT"] = "CWT";
    UnitOfMeasure["METRIC_TONS"] = "METRIC_TONS";
    UnitOfMeasure["PALLETS"] = "PALLETS";
    UnitOfMeasure["POUNDS"] = "POUNDS";
    UnitOfMeasure["TONS"] = "TONS";
})(UnitOfMeasure = exports.UnitOfMeasure || (exports.UnitOfMeasure = {}));
var UserAgreementType;
(function (UserAgreementType) {
    UserAgreementType["TermsAndConditions"] = "TermsAndConditions";
})(UserAgreementType = exports.UserAgreementType || (exports.UserAgreementType = {}));
var UserRole;
(function (UserRole) {
    UserRole["ARGONOMIST"] = "ARGONOMIST";
    UserRole["GROWER"] = "GROWER";
    UserRole["MARKETPLACE_BUYER"] = "MARKETPLACE_BUYER";
    UserRole["MARKETPLACE_SELLER"] = "MARKETPLACE_SELLER";
    UserRole["TRUCKING"] = "TRUCKING";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var UsersOrderByInput;
(function (UsersOrderByInput) {
    UsersOrderByInput["createdAt_ASC"] = "createdAt_ASC";
    UsersOrderByInput["createdAt_DESC"] = "createdAt_DESC";
    UsersOrderByInput["firstName_ASC"] = "firstName_ASC";
    UsersOrderByInput["firstName_DESC"] = "firstName_DESC";
    UsersOrderByInput["lastName_ASC"] = "lastName_ASC";
    UsersOrderByInput["lastName_DESC"] = "lastName_DESC";
    UsersOrderByInput["email_ASC"] = "email_ASC";
    UsersOrderByInput["email_DESC"] = "email_DESC";
})(UsersOrderByInput = exports.UsersOrderByInput || (exports.UsersOrderByInput = {}));
var USState;
(function (USState) {
    USState["ALABAMA"] = "ALABAMA";
    USState["ALASKA"] = "ALASKA";
    USState["AMERICAN_SAMOA"] = "AMERICAN_SAMOA";
    USState["ARIZONA"] = "ARIZONA";
    USState["ARKANSAS"] = "ARKANSAS";
    USState["CALIFORNIA"] = "CALIFORNIA";
    USState["COLORADO"] = "COLORADO";
    USState["CONNECTICUT"] = "CONNECTICUT";
    USState["DELAWARE"] = "DELAWARE";
    USState["DISTRICT_OF_COLUMBIA"] = "DISTRICT_OF_COLUMBIA";
    USState["FEDERATED_STATES_OF_MICRONESIA"] = "FEDERATED_STATES_OF_MICRONESIA";
    USState["FLORIDA"] = "FLORIDA";
    USState["GEORGIA"] = "GEORGIA";
    USState["GUAM"] = "GUAM";
    USState["HAWAII"] = "HAWAII";
    USState["IDAHO"] = "IDAHO";
    USState["ILLINOIS"] = "ILLINOIS";
    USState["INDIANA"] = "INDIANA";
    USState["IOWA"] = "IOWA";
    USState["KANSAS"] = "KANSAS";
    USState["KENTUCKY"] = "KENTUCKY";
    USState["LOUISIANA"] = "LOUISIANA";
    USState["MAINE"] = "MAINE";
    USState["MARSHALL_ISLANDS"] = "MARSHALL_ISLANDS";
    USState["MARYLAND"] = "MARYLAND";
    USState["MASSACHUSETTS"] = "MASSACHUSETTS";
    USState["MICHIGAN"] = "MICHIGAN";
    USState["MINNESOTA"] = "MINNESOTA";
    USState["MISSISSIPPI"] = "MISSISSIPPI";
    USState["MISSOURI"] = "MISSOURI";
    USState["MONTANA"] = "MONTANA";
    USState["NEBRASKA"] = "NEBRASKA";
    USState["NEVADA"] = "NEVADA";
    USState["NEW_HAMPSHIRE"] = "NEW_HAMPSHIRE";
    USState["NEW_JERSEY"] = "NEW_JERSEY";
    USState["NEW_MEXICO"] = "NEW_MEXICO";
    USState["NEW_YORK"] = "NEW_YORK";
    USState["NORTH_CAROLINA"] = "NORTH_CAROLINA";
    USState["NORTH_DAKOTA"] = "NORTH_DAKOTA";
    USState["NORTHERN_MARIANA_ISLANDS"] = "NORTHERN_MARIANA_ISLANDS";
    USState["OHIO"] = "OHIO";
    USState["OKLAHOMA"] = "OKLAHOMA";
    USState["OREGON"] = "OREGON";
    USState["PALAU"] = "PALAU";
    USState["PENNSYLVANIA"] = "PENNSYLVANIA";
    USState["PUERTO_RICO"] = "PUERTO_RICO";
    USState["RHODE_ISLAND"] = "RHODE_ISLAND";
    USState["SOUTH_CAROLINA"] = "SOUTH_CAROLINA";
    USState["SOUTH_DAKOTA"] = "SOUTH_DAKOTA";
    USState["TENNESSEE"] = "TENNESSEE";
    USState["TEXAS"] = "TEXAS";
    USState["UTAH"] = "UTAH";
    USState["VERMONT"] = "VERMONT";
    USState["VIRGIN_ISLANDS"] = "VIRGIN_ISLANDS";
    USState["VIRGINIA"] = "VIRGINIA";
    USState["WASHINGTON"] = "WASHINGTON";
    USState["WEST_VIRGINIA"] = "WEST_VIRGINIA";
    USState["WISCONSIN"] = "WISCONSIN";
    USState["WYOMING"] = "WYOMING";
})(USState = exports.USState || (exports.USState = {}));
var USStateAbbreviation;
(function (USStateAbbreviation) {
    USStateAbbreviation["AL"] = "AL";
    USStateAbbreviation["AK"] = "AK";
    USStateAbbreviation["AS"] = "AS";
    USStateAbbreviation["AZ"] = "AZ";
    USStateAbbreviation["AR"] = "AR";
    USStateAbbreviation["CA"] = "CA";
    USStateAbbreviation["CO"] = "CO";
    USStateAbbreviation["CT"] = "CT";
    USStateAbbreviation["DE"] = "DE";
    USStateAbbreviation["DC"] = "DC";
    USStateAbbreviation["FM"] = "FM";
    USStateAbbreviation["FL"] = "FL";
    USStateAbbreviation["GA"] = "GA";
    USStateAbbreviation["GU"] = "GU";
    USStateAbbreviation["HI"] = "HI";
    USStateAbbreviation["ID"] = "ID";
    USStateAbbreviation["IL"] = "IL";
    USStateAbbreviation["IN"] = "IN";
    USStateAbbreviation["IA"] = "IA";
    USStateAbbreviation["KS"] = "KS";
    USStateAbbreviation["KY"] = "KY";
    USStateAbbreviation["LA"] = "LA";
    USStateAbbreviation["ME"] = "ME";
    USStateAbbreviation["MH"] = "MH";
    USStateAbbreviation["MD"] = "MD";
    USStateAbbreviation["MA"] = "MA";
    USStateAbbreviation["MI"] = "MI";
    USStateAbbreviation["MN"] = "MN";
    USStateAbbreviation["MS"] = "MS";
    USStateAbbreviation["MO"] = "MO";
    USStateAbbreviation["MT"] = "MT";
    USStateAbbreviation["NE"] = "NE";
    USStateAbbreviation["NV"] = "NV";
    USStateAbbreviation["NH"] = "NH";
    USStateAbbreviation["NJ"] = "NJ";
    USStateAbbreviation["NM"] = "NM";
    USStateAbbreviation["NY"] = "NY";
    USStateAbbreviation["NC"] = "NC";
    USStateAbbreviation["ND"] = "ND";
    USStateAbbreviation["MP"] = "MP";
    USStateAbbreviation["OH"] = "OH";
    USStateAbbreviation["OK"] = "OK";
    USStateAbbreviation["OR"] = "OR";
    USStateAbbreviation["PW"] = "PW";
    USStateAbbreviation["PA"] = "PA";
    USStateAbbreviation["PR"] = "PR";
    USStateAbbreviation["RI"] = "RI";
    USStateAbbreviation["SC"] = "SC";
    USStateAbbreviation["SD"] = "SD";
    USStateAbbreviation["TN"] = "TN";
    USStateAbbreviation["TX"] = "TX";
    USStateAbbreviation["UT"] = "UT";
    USStateAbbreviation["VT"] = "VT";
    USStateAbbreviation["VI"] = "VI";
    USStateAbbreviation["VA"] = "VA";
    USStateAbbreviation["WA"] = "WA";
    USStateAbbreviation["WV"] = "WV";
    USStateAbbreviation["WI"] = "WI";
    USStateAbbreviation["WY"] = "WY";
})(USStateAbbreviation = exports.USStateAbbreviation || (exports.USStateAbbreviation = {}));
var USSubdivisionAbbreviation;
(function (USSubdivisionAbbreviation) {
    USSubdivisionAbbreviation["AL"] = "AL";
    USSubdivisionAbbreviation["AK"] = "AK";
    USSubdivisionAbbreviation["AS"] = "AS";
    USSubdivisionAbbreviation["AZ"] = "AZ";
    USSubdivisionAbbreviation["AR"] = "AR";
    USSubdivisionAbbreviation["CA"] = "CA";
    USSubdivisionAbbreviation["CO"] = "CO";
    USSubdivisionAbbreviation["CT"] = "CT";
    USSubdivisionAbbreviation["DE"] = "DE";
    USSubdivisionAbbreviation["DC"] = "DC";
    USSubdivisionAbbreviation["FM"] = "FM";
    USSubdivisionAbbreviation["FL"] = "FL";
    USSubdivisionAbbreviation["GA"] = "GA";
    USSubdivisionAbbreviation["GU"] = "GU";
    USSubdivisionAbbreviation["HI"] = "HI";
    USSubdivisionAbbreviation["ID"] = "ID";
    USSubdivisionAbbreviation["IL"] = "IL";
    USSubdivisionAbbreviation["IN"] = "IN";
    USSubdivisionAbbreviation["IA"] = "IA";
    USSubdivisionAbbreviation["KS"] = "KS";
    USSubdivisionAbbreviation["KY"] = "KY";
    USSubdivisionAbbreviation["LA"] = "LA";
    USSubdivisionAbbreviation["ME"] = "ME";
    USSubdivisionAbbreviation["MH"] = "MH";
    USSubdivisionAbbreviation["MD"] = "MD";
    USSubdivisionAbbreviation["MA"] = "MA";
    USSubdivisionAbbreviation["MI"] = "MI";
    USSubdivisionAbbreviation["MN"] = "MN";
    USSubdivisionAbbreviation["MS"] = "MS";
    USSubdivisionAbbreviation["MO"] = "MO";
    USSubdivisionAbbreviation["MT"] = "MT";
    USSubdivisionAbbreviation["NE"] = "NE";
    USSubdivisionAbbreviation["NV"] = "NV";
    USSubdivisionAbbreviation["NH"] = "NH";
    USSubdivisionAbbreviation["NJ"] = "NJ";
    USSubdivisionAbbreviation["NM"] = "NM";
    USSubdivisionAbbreviation["NY"] = "NY";
    USSubdivisionAbbreviation["NC"] = "NC";
    USSubdivisionAbbreviation["ND"] = "ND";
    USSubdivisionAbbreviation["MP"] = "MP";
    USSubdivisionAbbreviation["OH"] = "OH";
    USSubdivisionAbbreviation["OK"] = "OK";
    USSubdivisionAbbreviation["OR"] = "OR";
    USSubdivisionAbbreviation["PW"] = "PW";
    USSubdivisionAbbreviation["PA"] = "PA";
    USSubdivisionAbbreviation["PR"] = "PR";
    USSubdivisionAbbreviation["RI"] = "RI";
    USSubdivisionAbbreviation["SC"] = "SC";
    USSubdivisionAbbreviation["SD"] = "SD";
    USSubdivisionAbbreviation["TN"] = "TN";
    USSubdivisionAbbreviation["TX"] = "TX";
    USSubdivisionAbbreviation["UT"] = "UT";
    USSubdivisionAbbreviation["VT"] = "VT";
    USSubdivisionAbbreviation["VI"] = "VI";
    USSubdivisionAbbreviation["VA"] = "VA";
    USSubdivisionAbbreviation["WA"] = "WA";
    USSubdivisionAbbreviation["WV"] = "WV";
    USSubdivisionAbbreviation["WI"] = "WI";
    USSubdivisionAbbreviation["WY"] = "WY";
})(USSubdivisionAbbreviation = exports.USSubdivisionAbbreviation || (exports.USSubdivisionAbbreviation = {}));
var YieldUnit;
(function (YieldUnit) {
    YieldUnit["BUSHELS"] = "BUSHELS";
    YieldUnit["CWT"] = "CWT";
    YieldUnit["POUNDS"] = "POUNDS";
})(YieldUnit = exports.YieldUnit || (exports.YieldUnit = {}));
//# sourceMappingURL=enums.js.map